// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T20:36:58.117Z
// Property: Conrad at Concord Mills (ID: 5762658426945536)
// Collections: 24 amenities, 3 floorplans (live), 22 photos, 83 POIs, 8 reviews, 5 virtual tours, 6 office hours, 1 special offers (live), 18 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5695708787113984",
  "multihub_property_id": "5762658426945536",
  "property_external_id": "4939304",
  "property_zillow_url": "https://www.zillow.com/apartments/charlotte-nc/ardmore-king's-grant/B6n6C9/",
  "property_apartments_url": "https://www.apartments.com/conrad-at-concord-mills-charlotte-nc/5stcs7n",
  "property_google_business_url": "https://www.google.com/maps/place/Conrad+at+Concord+Mills/@35.3682806,-80.7340834,15z/data=!4m2!3m1!1s0x0:0xebe5a53730eadc72?sa=X&ved=2ahUKEwie95v7yO72AhWumGoFHXgCDIUQ_BJ6BAgpEAU",
  "property_linkedin_url": null,
  "property_hubspot_id": "8443831915",
  "property_crm_software": "Rent Dynamics",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "conrad-at-concord-mills",
  "property_name": "Conrad at Concord Mills",
  "property_website_url": "https://www.conradatconcordmills.com/",
  "property_domain": "https://www.conradatconcordmills.com/",
  "property_address": "9015 Kings Grant Dr",
  "property_full_address": "9015 Kings Grant Dr, Charlotte, NC 28262",
  "property_address_1": "9015 Kings Grant Dr",
  "property_address_2": null,
  "property_address_city": "Charlotte",
  "property_address_state": "NC",
  "property_address_zip_full": "28262-7578",
  "property_address_zip": "28262",
  "property_address_country": "US",
  "property_address_county": "Mecklenburg County",
  "property_neighborhood_address": "Mallard Creek - Withrow Downs",
  "property_address_latitude": "35.3685384",
  "property_address_longitude": "-80.7321822",
  "property_email": "conrad@alapts.com",
  "property_phone": "(980) 237-6891",
  "property_call_tracking_phone": "980-447-5717",
  "property_company_name": "American Landmark",
  "property_company_url": "https://www.alapts.com/",
  "agency_contacts": null,
  "property_type": "apartment",
  "property_short_description": "<p><strong>Resort-style comfort near Concord Mills.</strong> Choose polished one-, two-, and three-bedroom apartments with granite countertops, designer cabinetry, wood-style flooring, tall ceilings, and select private outdoor space—then explore <a href=\"/floor-plans\">available floor plans</a> to find your fit.</p>",
  "property_long_description": "<p><strong>Resort-style comfort in the Concord Mills corridor.</strong> At Conrad at Concord Mills, you can choose from one-, two-, and three-bedroom apartments with upgraded finishes that feel polished from the first step inside: granite countertops, subway tile backsplash, designer cabinetry, wood-style flooring, crown molding, tall ceilings, USB outlets, walk-in closets, and private outdoor space in select homes.</p><p>Beyond your door, <a href=\"/amenities\">community amenities</a> make everyday living easier, from a resort-inspired pool, 24-hour fitness center, Wi-Fi business lounge, Starbucks coffee bar, grilling pavilion, EV charging, available garages, and a fenced dog park with pet wash. The Mallard Creek–Withrow Downs location keeps you close to Concord Mills, SEA LIFE Charlotte-Concord, dining, movies, Charlotte Motor Speedway, UNC Charlotte, and the University City corridor, with I-85 and I-485 nearby for getting across Charlotte. Explore <a href=\"/floor-plans\">available floor plans</a> and see how connected, comfortable apartment living can feel.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019d02f4-dbc3-77db-931a-a9504819e165.webp",
  "property_featured_image_media": {
    "alt_text": "Swimming pool and lounge area with umbrellas and chairs.",
    "public_id": "019d02f4-dbc3-77db-931a-a9504819e165",
    "storage_key": "property/5762658426945536/019d02f4-dbc3-77db-931a-a9504819e165.webp",
    "width": 1240,
    "height": 826
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "357",
  "property_year_built": "2015",
  "property_year_renovated": "2022",
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "94.39775910364145",
  "property_admin_fee": "250",
  "property_application_fee": "85",
  "property_fees_deposit_info": "Application Fee: $85\nAdministrative Fee: $250\nApplication Approval Fee: Starting at $399\nPet Fee: $400/pet\nMonthly Pet Rent: $30/pet",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "400",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions may apply. Contact us for more information.",
  "property_pet_policy_description": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $400 per pet, with a monthly pet rent of $30 per pet. Breed restrictions may apply.",
  "property_petpolicy_info": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $400 per pet, with a monthly pet rent of $30 per pet. Breed restrictions may apply.",
  "property_online_leasing_url": "https://8821000.onlineleasing.realpage.com",
  "property_resident_portal_url": "https://conrad.loftliving.com/login",
  "property_apply_now_url": "https://8821000.onlineleasing.realpage.com",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019e4d6d-2927-703a-8c25-c96133590910.webp",
  "property_primary_logo_media": {
    "alt_text": "Conrad at Concord Mills logo",
    "public_id": "019e4d6d-2927-703a-8c25-c96133590910",
    "storage_key": "property/5762658426945536/019e4d6d-2927-703a-8c25-c96133590910.webp",
    "width": 3072,
    "height": 3072
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019d02f4-cfef-7714-8437-4bd57a059a61.webp",
  "property_secondary_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02f4-cfef-7714-8437-4bd57a059a61",
    "storage_key": "property/5762658426945536/019d02f4-cfef-7714-8437-4bd57a059a61.webp",
    "width": 325,
    "height": 147
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019e4d6d-7dd6-726b-b22b-c61ef48fc537.webp",
  "property_icon_media": {
    "alt_text": "Abstract blue and gray C logo",
    "public_id": "019e4d6d-7dd6-726b-b22b-c61ef48fc537",
    "storage_key": "property/5762658426945536/019e4d6d-7dd6-726b-b22b-c61ef48fc537.webp",
    "width": 512,
    "height": 512
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019e4d6d-7dd6-726b-b22b-c61ef48fc537.webp",
  "property_fav_icon_media": {
    "alt_text": "Abstract blue and gray C logo",
    "public_id": "019e4d6d-7dd6-726b-b22b-c61ef48fc537",
    "storage_key": "property/5762658426945536/019e4d6d-7dd6-726b-b22b-c61ef48fc537.webp",
    "width": 512,
    "height": 512
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019e4d6d-292f-7272-9e77-09adc9eac380.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Conrad at Concord Mills logo",
    "public_id": "019e4d6d-292f-7272-9e77-09adc9eac380",
    "storage_key": "property/5762658426945536/019e4d6d-292f-7272-9e77-09adc9eac380.webp",
    "width": 3072,
    "height": 3072
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019e4d6d-2a03-7753-bbb3-178b8832f586.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Conrad at Concord Mills logo",
    "public_id": "019e4d6d-2a03-7753-bbb3-178b8832f586",
    "storage_key": "property/5762658426945536/019e4d6d-2a03-7753-bbb3-178b8832f586.webp",
    "width": 3072,
    "height": 3072
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-af4c-707a-be5f-eaefee6b31cf.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
  "property_company_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-c9dc-7579-9b73-fbe42f847d6f",
    "storage_key": "company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
    "width": 1968,
    "height": 884
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-b73c-7581-ab8a-b01c3434f867",
    "storage_key": "company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
    "width": 2565,
    "height": 1000
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "American Landmark logo on a black background",
    "public_id": "019d02ed-bfec-74fd-b5d0-5a699636306b",
    "storage_key": "company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
    "width": 2565,
    "height": 1000
  },
  "property_primary_color": "#006ea8",
  "property_secondary_color": "#50b0e1",
  "property_font_color": "#2e2a25",
  "property_color_4": "#7d8280",
  "property_color_3": "#626463",
  "property_color_5": "#ffffff",
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "740 - 1430",
  "property_sqft_min": "740",
  "property_sqft_max": "1430",
  "property_price_range": "1145 - 1835",
  "property_price_min": "1145",
  "property_price_max": "1835",
  "property_available_units": 20,
  "property_facebook_url": "https://www.facebook.com/ConradatConcordMills",
  "property_instagram_url": "https://www.instagram.com/conradatconcordmillsapts",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJH7FanrwcVIgRctzqMDel5es",
  "property_youtube_url": "https://www.youtube.com/@ConradatConcordMillsApartments",
  "property_yelp_url": "https://www.yelp.com/search?find_desc=Apartments&find_loc=Concord%2C+NC",
  "property_tiktok_url": "https://www.tiktok.com/@conradatconcordmills",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": null,
  "property_home_amenities_blurb": "<p><strong>Everyday ease, built in.</strong><br>Start with a 24-hour fitness center, Wi-Fi business lounge, and Starbucks coffee bar, then shift into downtime at the pool or outdoor grilling pavilion. Pet-friendly perks include a fenced pet park with agility features and a nearby pet wash station, while apartments add polished finishes like granite countertops, subway tile, wood-style flooring, walk-in closets, USB outlets, and smart locks.</p>",
  "property_home_floorplans_blurb": "<p><strong>Room to choose, finishes to notice.</strong> Explore one-, two-, and three-bedroom apartments at Conrad at Concord Mills with bright layouts and polished details like wood-style flooring, tall ceilings with crown molding, granite countertops, subway tile backsplash, designer cabinetry, USB outlets, walk-in closets, and washer/dryer connections. Select homes also offer private outdoor space, giving each floor plan an easy, contemporary feel worth seeing up close.</p>",
  "property_home_gallery_blurb": "<p><strong>Preview life at Conrad at Concord Mills.</strong> Flip through bright interiors with granite counters, subway tile, designer cabinetry, wood-style flooring, and crown molding, then step into community spaces made for everyday ease. From the pool deck to the Wi-Fi business lounge, coffee bar, and open-air gathering areas, the gallery gives you a sharper look before you visit in Charlotte.</p>",
  "property_home_neighborhood_blurb": "<p><strong>More Charlotte-area highlights, minutes from home.</strong> From Conrad at Concord Mills, shopping, dining, fresh air, and entertainment are easy to map out. Browse Concord Mills, catch a movie, or visit SEA LIFE Charlotte-Concord, then unwind at Mallard Creek Park, Clarks Creek Greenway, or UNC Charlotte Botanical Gardens. With University City dining, PNC Music Pavilion, Charlotte Motor Speedway, I-85, I-485, and the LYNX Blue Line nearby, the neighborhood keeps every plan within reach.</p>",
  "property_home_reviews_blurb": "<p><strong>See what stands out at Conrad at Concord Mills.</strong> Reviews call out the helpful leasing team, responsive maintenance, modern apartment finishes, and a location close to shopping and dining. From well-kept amenities to pet-friendly conveniences, the feedback offers a clear look at daily life here—plus details like “beautiful and modern” apartments residents are excited to share.</p>",
  "property_neighborhood_blurb": "<p><strong>Map out a day with more built in.</strong> At Conrad at Concord Mills, your Mallard Creek–Withrow Downs address puts shopping, dining, outdoor time, and Charlotte-area entertainment within easy reach. Head to Concord Mills for outlet finds, movies, and SEA LIFE Charlotte-Concord, then trade the retail buzz for fresh air along Mallard Creek Park, Clarks Creek Greenway, or nearby UNC Charlotte Botanical Gardens.</p><p>When plans call for a bite out, West Mallard Creek Church Road and University City serve up local flavor—from Thai Taste and Godavari to Boardwalk Billy’s—while PNC Music Pavilion and Charlotte Motor Speedway bring big-event energy close to home. With I-85, I-485, and the UNC Charlotte LYNX Blue Line station nearby, you can keep your week moving and your weekends open. Ready to see the area for yourself? <a href=\"/schedule-a-tour\">Schedule a tour</a>.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>More built into your day.</strong><br>At Conrad at Concord Mills, amenities are designed to make everyday routines feel smoother, from the 24-hour fitness center and Wi-Fi business lounge to the Starbucks coffee bar that keeps mornings moving. When it is time to unwind, head for the pool, gather around the outdoor grilling pavilion, or let your four-legged roommate enjoy the fenced pet park with agility features and a pet wash station nearby.</p><p>Inside your apartment, polished details add comfort without overcomplicating the space: granite countertops, subway tile backsplash, designer cabinetry, wood-style flooring, tall ceilings, walk-in closets, washer and dryer connections, USB outlets, and smart locks. See how these finishes come together in the <a href=\"/gallery\">photo gallery</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to experience the amenities in person.</p>",
  "property_applynow_blurb": "<p><strong>Start your application with confidence.</strong> Conrad at Concord Mills pairs polished one-, two-, and three-bedroom <a href=\"/floor-plans\">apartment layouts</a> with resort-style comfort, upgraded finishes, and everyday conveniences designed to make home feel easy. Apply online today and take the next step toward connected, comfortable living.</p>",
  "property_contactus_blurb": "<p><strong>Have questions or need directions?</strong> Contact the leasing team at Conrad at Concord Mills for help exploring our one-, two-, and three-bedroom apartments, upgraded finishes, and connected Mallard Creek–Withrow Downs location near I-85 and I-485. We’re here to make your next step simple.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Conrad at Concord Mills?</strong> Start here for quick answers on apartment options, upgraded finishes, resort-style amenities, leasing details, and everyday living in the Concord Mills corridor. If you need anything else, the leasing team is happy to help.</p>",
  "property_floorplans_blurb": "<p><strong>Find the floor plan that fits your day.</strong> Conrad at Concord Mills offers one-, two-, and three-bedroom apartments with layouts that give you room to settle in, spread out, and make each space work your way. Compare available options below, then look for everyday details that add polish and practicality: wood-style flooring, tall ceilings with crown molding, granite countertops, subway tile backsplash, designer cabinetry, USB outlets, walk-in closets, and washer and dryer connections.</p><p>Whether you want a streamlined one-bedroom or a larger layout with extra bedroom space, each home is designed with a bright, contemporary feel and select apartments include private outdoor space. Browse current availability, view finishes in the <a href=\"/gallery\">photo gallery</a>, and <a href=\"/schedule-a-tour\">schedule a tour</a> when you’re ready to see your favorite layout in person.</p>",
  "property_gallery_blurb": "<p><strong>Take a closer look at the spaces that shape daily life at Conrad at Concord Mills.</strong> Browse photos that move from bright apartment interiors to inviting community spots, giving you a real sense of color, finish, and flow before you visit in Charlotte.</p><p>Picture a kitchen with granite counters, crisp subway tile, and designer cabinetry, then a living area warmed by wood-style flooring and crown molding. Outside the apartment, the gallery captures the pool deck, Wi-Fi business lounge, coffee bar, and open-air gathering spaces in vivid detail. Like what you see? Compare <a href=\"/floor-plans\">available floor plans</a>, explore <a href=\"/virtual-tours\">virtual tours</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see your favorite spaces in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore the Concord Mills corridor.</strong> Use the interactive map to browse <a href=\"/floor-plans\">available apartments</a>, see what’s nearby, and get a feel for the Mallard Creek–Withrow Downs location with dining, movies, University City, and major Charlotte routes within easy reach.</p>",
  "property_pets_blurb": "<p><strong>Room to roam, rinse, and relax.</strong> Pet-friendly living at Conrad at Concord Mills is built around the routines that make apartment life easier with a cat or dog. Start with spacious layouts that give everyone a comfortable place to settle, then head outside to the fenced pet park with agility features when your pup needs a change of scenery. After muddy paws or a big play session, the on-site pet wash station helps keep cleanup simple.</p><p>Beyond the community, the Mallard Creek area puts everyday pet errands within easy reach, from nearby supplies to greenway walks when you want a longer outing. Explore more <a href=\"/amenities\">pet-friendly amenities</a>, compare <a href=\"/floor-plans\">available floor plans</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see how life here works for you and your companion.</p>",
  "property_referafriend_blurb": "<p><strong>Share resort-style comfort.</strong> Love the polished finishes, private outdoor space, poolside downtime, 24-hour fitness, and easy Concord Mills corridor connection? Invite a friend to make Conrad at Concord Mills their next home—send a referral and let them see what makes everyday living here feel so connected and comfortable.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident access, made easy.</strong><br>Log in to pay rent, submit maintenance requests, and manage your Conrad at Concord Mills account—so you can get back to resort-style comfort, upgraded finishes, and connected everyday living.</p>",
  "property_reviews_blurb": "<p><strong>Real feedback from people who know Conrad at Concord Mills best.</strong> As you read through the reviews, you’ll see residents highlight the helpful leasing team, responsive maintenance, modern apartment finishes, and a location that keeps shopping and restaurants close by.</p><p>Residents often point to the value of the space, the well-kept amenities, and the pet-friendly conveniences as reasons they enjoy calling Conrad home. One reviewer summed it up simply: “Apartment is beautiful and modern.” Explore the feedback below to see what everyday living here feels like from the resident perspective.</p>",
  "property_created_at": "1752256735756",
  "property_scheduletour_blurb": "<p><strong>See the polished details in person.</strong> Tour Conrad at Concord Mills and get a closer look at granite countertops, subway tile backsplash, designer cabinetry, wood-style flooring, tall ceilings, and select private outdoor spaces—plus resort-inspired community features designed to make everyday living feel easier.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—your inquiry has been received.</strong> The Conrad at Concord Mills leasing team will be in touch soon. In the meantime, picture resort-style comfort with polished apartment finishes, inviting shared spaces, and a connected Concord Mills corridor location that makes everyday living feel easy.</p>",
  "property_virtualtours_blurb": "<p><strong>Step inside before you stop by.</strong> These virtual tours let you move through Conrad at Concord Mills at your own pace, from a two-bedroom, two-bath apartment to the community spaces that shape daily routines. In the apartment tour, look for the open living area, French doors, crown molding, wood-style flooring, and a kitchen with white cabinetry, granite counters, subway tile, and a seated peninsula.</p><p>Then switch views to the community tour, fitness center, pool, and amenities center to see how the shared spaces connect: bright workout rooms with cardio and strength zones, a lounge with dramatic ceilings and natural light, and a pool deck with shaded seating. Like what you see? Compare <a href=\"/floor-plans\">available floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_copyright": "2025 All Rights Reserved. Conrad at Concord Mills",
  "property_seo_title_home": "Conrad at Concord Mills | Apartments in Charlotte, NC",
  "property_seo_description_home": "Discover your dream apartment at Conrad at Concord Mills in Charlotte, NC! Choose from our spacious one, two, and three-bedroom floor plans designed for modern living. Enjoy premium amenities like a state-of-the-art fitness center, relaxing pool, and dog park, all complemented by stylish interiors featuring crown molding, tile backsplashes, and walk-in closets. With convenient online resident services and added perks like car charging stations and USB outlets, elevate your lifestyle today! Find your new home and experience the comfort and luxury you deserve!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 3 Apartments in Charlotte, NC",
  "property_seo_description_floorplans": "Discover your ideal living space at Conrad at Concord Mills in Charlotte, NC! Explore our thoughtfully designed one, two, and three-bedroom floor plans tailored to fit your lifestyle. Whether you seek cozy comfort or spacious elegance, we have the perfect home for you. Browse our available apartment homes today and take the first step toward your new life!",
  "property_seo_title_amenities": "Amenities | Charlotte, NC Apartments for Rent",
  "property_seo_description_amenities": "Discover modern living at Conrad at Concord Mills in Charlotte, NC! Our spacious one, two, and three-bedroom floor plans come filled with premium amenities like a state-of-the-art fitness center, dog park, and sparkling pool. Enjoy luxury touches including crown molding, smart locks, and USB outlets in every home. Need convenience? We offer online resident services and car charging stations. Explore our amazing community amenities and apartment features today!",
  "property_seo_title_gallery": "Gallery | Apartments in Charlotte, NC",
  "property_seo_description_gallery": "Discover your dream home at Conrad at Concord Mills in Charlotte, NC! Explore our stunning photo gallery showcasing spacious one, two, and three-bedroom floor plans designed with premium amenities like a fitness center, dog park, and coffee bar. Unwind by the pool, enjoy our grilling area, or work in the Wi-Fi business lounge—all complemented by stylish finishes such as crown molding and modern kitchen appliances. Picture yourself living here and experience the American Landmark 360 lifestyle!",
  "property_seo_title_virtualtours": "Virtual Tours | Conrad at Concord Mills Apartments",
  "property_seo_description_virtualtours": "Discover your perfect home at Conrad at Concord Mills in Charlotte, NC! Explore our diverse floor plans, featuring one, two, and three-bedroom apartments designed for modern living. Take a virtual tour of our community and see why residents love calling us home. Don't wait—experience your future apartment today!",
  "property_seo_title_interactivemap": "Interactive Map | Conrad at Concord Mills Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at Conrad at Concord Mills, Charlotte’s premier apartment community! Choose from spacious one, two, and three-bedroom floor plans featuring modern amenities like smart locks, a state-of-the-art fitness center, and dog park. Enjoy cozy evenings at our coffee bar or take a refreshing dip in the pool. With an interactive community map, it’s easy to explore available apartments, view pricing, and find your dream home today! Embrace upscale living with premium finishes and a convenient location in Charlotte, NC. ",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Charlotte, NC",
  "property_seo_description_neighborhood": "Discover the vibrant neighborhood surrounding Conrad at Concord Mills in Charlotte, NC! Explore our one, two, and three-bedroom floor plans while uncovering local favorites and nearby points of interest. See what’s around our community and start your next adventure today!",
  "property_seo_title_contact": "Contact Us | Conrad at Concord Mills",
  "property_seo_description_contact": "Discover your perfect home at Conrad at Concord Mills in Charlotte, NC! Explore our diverse floor plans, featuring one, two, and three-bedroom apartments tailored to your lifestyle. Have questions? Contact our leasing team today for personalized assistance and make your dream apartment a reality!",
  "property_seo_title_faqs": "FAQs | Apartments in Charlotte, NC",
  "property_seo_description_faqs": "Discover life at Conrad at Concord Mills in Charlotte, NC, where modern living meets comfort. Explore our diverse floor plans, including one, two, and three-bedroom apartments equipped with premium amenities like a fitness center, pool, dog park, and smart locks. Have questions? Browse our FAQs page to find answers about our vibrant community and outstanding features. Live well, live smart at Conrad at Concord Mills!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Charlotte, NC",
  "property_seo_description_reviews": "Discover the vibrant living experience at Conrad at Concord Mills in Charlotte, NC! Explore our diverse floor plans, including one, two, and three-bedroom apartments, designed with modern amenities like smart locks, walk-in closets, and energy-efficient kitchen appliances. Enjoy exclusive perks such as a fitness center, dog park, and relaxing pool area, along with convenient online resident services. Don’t just take our word for it—see what our residents have to say about life in our exceptional community! Join us today and experience unparalleled comfort and convenience.",
  "property_seo_title_applynow": "Apply Now | Apartments in Charlotte, NC",
  "property_seo_description_applynow": "Discover your ideal living space at Conrad at Concord Mills in Charlotte, NC! Choose from thoughtfully designed one, two, and three-bedroom floor plans featuring modern amenities like smart locks, walk-in closets, and premium finishes. Enjoy exclusive community perks including a fitness center, dog park, and relaxing pool area. Apply for your new home and lease online today to experience the perfect blend of luxury and comfort!",
  "property_seo_title_residentaccess": "Resident Access | Conrad at Concord Mills",
  "property_seo_description_residentaccess": "\"Welcome to Conrad at Concord Mills in Charlotte, NC! Log in to your resident portal for easy rent payments, seamless maintenance scheduling, and exclusive community updates. Access all your resident needs in one convenient place!\"",
  "property_seo_title_referafriend": "Refer A Friend | Conrad at Concord Mills",
  "property_seo_description_referafriend": "\"Discover the joy of community at Conrad at Concord Mills in Charlotte, NC! Great friends make great neighbors—refer a friend today and enjoy exclusive rewards. Embrace vibrant living together!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Conrad at Concord Mills",
  "property_seo_description_scheduletour": "\"Discover luxurious living at Conrad at Concord Mills in Charlotte, NC. Schedule a tour today to explore our stunning amenities, spacious apartments, and vibrant community. Your new home awaits!\"",
  "property_seo_title_privacy": "Privacy Policy | Conrad at Concord Mills",
  "property_seo_description_privacy": "\"Discover peace of mind at Conrad at Concord Mills in Charlotte, NC. Our privacy policy outlines how we protect your information and ensure a secure living experience. View our privacy policy to learn more!\"",
  "property_seo_title_accessibility": "Website Accessibility | Conrad at Concord Mills",
  "property_seo_description_accessibility": "Discover accessible living at Conrad at Concord Mills in Charlotte, NC! Our commitment to digital inclusion ensures everyone can explore our vibrant community. Learn more about our accessibility features and how we enhance your living experience. Visit us today!",
  "property_seo_title_sitemap": "Sitemap | Conrad at Concord Mills",
  "property_seo_description_sitemap": "Explore the Conrad at Concord Mills in Charlotte, NC! Discover our comprehensive sitemap to navigate our vibrant apartment community and find everything you need, from floor plans to amenities. Visit our website now!",
  "property_seo_title_thankyou": "Thank You | Conrad at Concord Mills",
  "property_seo_description_thankyou": "\"Thank you for reaching out to Conrad at Concord Mills in Charlotte, NC! We're excited to assist you in your apartment search. A member of our dedicated team will contact you shortly to provide personalized assistance and answer any questions. Discover your new home with us!\"",
  "property_seo_title_pets": "Pet Policy | Apartments in Riverview, FL",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793651137143",
  "amenities": [
    {
      "id": "custom_f6a8be16-6f10-4531-9915-a120a8b1688a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "custom",
      "external_id": "P000000597",
      "title": "American Landmark 360",
      "amount": "0.0000",
      "description": "American Landmark 360 Resident Program",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d111b084-cc7a-4841-afe0-cd9dccf778a7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "custom",
      "external_id": "P000000609",
      "title": "Cabinets",
      "amount": "0.0000",
      "description": "Designer Cabinetry",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bd2141a2-e3b0-43ee-a9dc-fbe92995deda",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "custom",
      "external_id": "P000000610",
      "title": "Car Charging Stations",
      "amount": "0.0000",
      "description": "Electric Car Charging Stations",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8eaeca11-327a-4567-8a14-46d8c80f43c8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "custom",
      "external_id": "P000000615",
      "title": "Coffee Bar",
      "amount": "0.0000",
      "description": "Resident Coffee Bar",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8d281193-bd68-46bb-851d-86131e480d85",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "custom",
      "external_id": "P000000621",
      "title": "Counters",
      "amount": "0.0000",
      "description": "Sleek Granite Countertops",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9ed734b0-15c3-47bb-8d0c-95ad596cd4e8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "custom",
      "external_id": "P000000624",
      "title": "Crown Molding",
      "amount": "0.0000",
      "description": "Decorative Crown Molding",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b6d5bc26-f155-42bd-818b-8d889e6aa21c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "custom",
      "external_id": "P000000626",
      "title": "Dog Park",
      "amount": "0.0000",
      "description": "Bark Park and Posh Pet Spa",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_00f7408f-7d98-4818-a4ce-93536d17f7ac",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "custom",
      "external_id": "P000000631",
      "title": "Fan",
      "amount": "0.0000",
      "description": "Remote Controlled Ceiling Fans",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7180a30b-6cf9-49ad-82d9-1ae73beab617",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "custom",
      "external_id": "P000000635",
      "title": "Fitness Center",
      "amount": "0.0000",
      "description": "Modern 24-Hour Fitness Center",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9ca7af0a-da83-4b48-a759-44fb33b92668",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "custom",
      "external_id": "P000000640",
      "title": "Garages",
      "amount": "0.0000",
      "description": "Garages*",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3a196c4d-f2ff-4b3e-97b3-7b07d26ed6f3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "custom",
      "external_id": "P000000644",
      "title": "Grill Area",
      "amount": "0.0000",
      "description": "Grilling Station",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2901d421-1562-44b6-832e-9e2595171927",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "custom",
      "external_id": "P000000646",
      "title": "Hard Floors",
      "amount": "0.0000",
      "description": "Wood-Style Vinyl Flooring",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f19e0aa3-dc8a-436b-ab1c-156255eee609",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "custom",
      "external_id": "P000000651",
      "title": "Kitchen Appliances",
      "amount": "0.0000",
      "description": "Black Appliances",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_84876639-6b29-4fcf-8a58-c43e1d350684",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "custom",
      "external_id": "P000000660",
      "title": "Online Resident Services",
      "amount": "0.0000",
      "description": "Convenient 24/7 Online Resident Services",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_847a7a6f-6b28-459d-b631-3e8b7e2ac89d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "custom",
      "external_id": "P000000663",
      "title": "Outside Space",
      "amount": "0.0000",
      "description": "Private Patios and Balconies",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c22f045f-41f4-4bd1-920f-dfeeb55e547e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "custom",
      "external_id": "P000000669",
      "title": "Pool",
      "amount": "0.0000",
      "description": "Resort-Style Swimming Pool",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_386ab586-4e24-4489-8e7f-164afa95d4c7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "custom",
      "external_id": "P000000675",
      "title": "Select Homes",
      "amount": "0.0000",
      "description": "*In Select Homes",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_072d578d-b325-4b61-af29-5552312d03a2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "custom",
      "external_id": "P000000690",
      "title": "Tall Ceilings",
      "amount": "0.0000",
      "description": "9` Ceilings",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_15566559-5ec4-47b8-bbbd-9539923262fe",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "custom",
      "external_id": "P000000695",
      "title": "Tile Backsplash",
      "amount": "0.0000",
      "description": "Subway Tile Backsplash",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9e4564c9-f38f-4932-b4f8-4cbf7b0a861f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "custom",
      "external_id": "P000000698",
      "title": "USB Outlet",
      "amount": "0.0000",
      "description": "USB Outlets",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c538e735-ad6d-4dac-bd65-ecc3fd052e3b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "custom",
      "external_id": "P000000703",
      "title": "W&D Connections",
      "amount": "0.0000",
      "description": "Washer and Dryer Connections",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c7b30679-cac5-4f43-adc9-da26d82771c8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "custom",
      "external_id": "P000000705",
      "title": "Walk-In Closet",
      "amount": "0.0000",
      "description": "Generous Walk-In Closets",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8916c6a1-7711-4d86-9b22-0e19365fef08",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "custom",
      "external_id": "P000001372",
      "title": "Lounge",
      "amount": "0.0000",
      "description": "Resident Lounge",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d25192c7-255c-4e87-bf23-ccae6c4ca468",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "custom",
      "external_id": "P000002469",
      "title": "Wi-Fi Business Lounge",
      "amount": "0.0000",
      "description": "Wi-Fi Lounge",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_e9719292-50ee-4062-b2aa-3774ca7ed950",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019e898f-1d2e-725e-8adc-2b19c411c4f4.webp",
      "image_media": {
        "alt_text": "Covered outdoor patio with grills, seating, and tables.",
        "public_id": "019e898f-1d2e-725e-8adc-2b19c411c4f4",
        "storage_key": "property/5762658426945536/019e898f-1d2e-725e-8adc-2b19c411c4f4.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy outdoor gatherings at our community patio, featuring gas grills, comfortable seating, and dining tables perfect for entertaining.",
      "link": "",
      "alt_text": "Covered outdoor patio with grills, seating, and tables.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fedc2398-f76b-448a-92a7-5dde48b3a5b4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019e898f-1b59-71ab-b16b-235326c2ac26.webp",
      "image_media": {
        "alt_text": "Fenced-in dog park with agility equipment and a bench.",
        "public_id": "019e898f-1b59-71ab-b16b-235326c2ac26",
        "storage_key": "property/5762658426945536/019e898f-1b59-71ab-b16b-235326c2ac26.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy our on-site dog park, complete with agility equipment for your furry friends. A perfect place for pets to play and socialize.",
      "link": "",
      "alt_text": "Fenced-in dog park with agility equipment and a bench.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_19f38350-478c-475e-9d82-55a9e663f6fc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019e898f-1cd8-722a-a81e-be5ae0a78138.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, nightstand, and an opening to a bathroom.",
        "public_id": "019e898f-1cd8-722a-a81e-be5ae0a78138",
        "storage_key": "property/5762658426945536/019e898f-1cd8-722a-a81e-be5ae0a78138.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a plush king-size bed, decorative pillows, and elegant wallpaper. The adjacent bathroom is visible through an open doorway.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, nightstand, and an opening to a bathroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_452a5047-41e6-44bf-81df-5d79cb49e2ca",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019e898f-0e5a-7489-a2a2-81cbfb4c9f18.webp",
      "image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool and hot tub area with lounge chairs and umbrellas at a multifamily property.",
        "public_id": "019e898f-0e5a-7489-a2a2-81cbfb4c9f18",
        "storage_key": "property/5762658426945536/019e898f-0e5a-7489-a2a2-81cbfb4c9f18.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a relaxing day by the sparkling swimming pool and hot tub, complete with comfortable lounge chairs and shaded umbrellas.",
      "link": "",
      "alt_text": "Aerial view of a resort-style swimming pool and hot tub area with lounge chairs and umbrellas at a multifamily property.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c86355ce-d60d-41fa-a000-d82b44d2c614",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019e898f-0de9-73c1-b99b-b046fba642a4.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area in an apartment with modern furniture.",
        "public_id": "019e898f-0de9-73c1-b99b-b046fba642a4",
        "storage_key": "property/5762658426945536/019e898f-0de9-73c1-b99b-b046fba642a4.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Step into this beautifully appointed apartment, featuring a spacious living area seamlessly connected to a modern kitchen and dining space. Perfect for entertaining or relaxing.",
      "link": "",
      "alt_text": "Living room and kitchen area in an apartment with modern furniture.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6a1e32b7-e433-45ee-a978-86d72bd28d90",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019e898f-0fec-71ad-82ce-1922af6b2c85.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, and black appliances.",
        "public_id": "019e898f-0fec-71ad-82ce-1922af6b2c85",
        "storage_key": "property/5762658426945536/019e898f-0fec-71ad-82ce-1922af6b2c85.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring sleek white cabinetry, elegant granite countertops, and a full suite of black appliances, perfect for any home chef.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, granite countertops, and black appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_377db8de-b2b7-411a-ae6b-667a741e19f0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019e898f-0592-77ac-a6ca-8e156c49a541.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and staircases, surrounded by trees and green lawns.",
        "public_id": "019e898f-0592-77ac-a6ca-8e156c49a541",
        "storage_key": "property/5762658426945536/019e898f-0592-77ac-a6ca-8e156c49a541.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Beautifully maintained apartment buildings with modern architecture, offering comfortable living spaces with private balconies and easy access.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with balconies and staircases, surrounded by trees and green lawns.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b1a340da-8cf2-4762-86dc-d2544d26c9cd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019e898f-0580-7087-9a63-757ab42dc320.webp",
      "image_media": {
        "alt_text": "Modern living room with white sofa, coffee table, TV stand, and open kitchen area.",
        "public_id": "019e898f-0580-7087-9a63-757ab42dc320",
        "storage_key": "property/5762658426945536/019e898f-0580-7087-9a63-757ab42dc320.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious living area flows seamlessly into a modern kitchen, perfect for entertaining or relaxing.",
      "link": "",
      "alt_text": "Modern living room with white sofa, coffee table, TV stand, and open kitchen area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0ec3f665-6f87-4412-966d-cddd8eab105c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019e898f-06a7-75ce-aa62-9ddc5cc0581c.webp",
      "image_media": {
        "alt_text": "Secure package lockers with the Conrad at Concord Mills branding.",
        "public_id": "019e898f-06a7-75ce-aa62-9ddc5cc0581c",
        "storage_key": "property/5762658426945536/019e898f-06a7-75ce-aa62-9ddc5cc0581c.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Convenient and secure package lockers available for all residents at Conrad at Concord Mills, offering 24/7 access to your deliveries.",
      "link": "",
      "alt_text": "Secure package lockers with the Conrad at Concord Mills branding.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3cc566ce-0a23-4fce-9e49-918c8133807c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019e898f-062b-746b-a9e5-e1e615ef1375.webp",
      "image_media": {
        "alt_text": "Community lounge area with a blue retro refrigerator, coffee maker, sink, and modern decor.",
        "public_id": "019e898f-062b-746b-a9e5-e1e615ef1375",
        "storage_key": "property/5762658426945536/019e898f-062b-746b-a9e5-e1e615ef1375.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy a refreshing drink or a cup of coffee in our stylish community lounge, featuring a vibrant retro refrigerator and a convenient coffee station.",
      "link": "",
      "alt_text": "Community lounge area with a blue retro refrigerator, coffee maker, sink, and modern decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_82f0481e-3958-4eec-887c-4ce644655687",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019e898e-ff74-7355-bf06-9394c2b399d8.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with hangers and a folded robe on a stool",
        "public_id": "019e898e-ff74-7355-bf06-9394c2b399d8",
        "storage_key": "property/5762658426945536/019e898e-ff74-7355-bf06-9394c2b399d8.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet with white wire shelving, wooden hangers, and a plush robe folded on a wooden stool, ready for your personal touch.",
      "link": "",
      "alt_text": "Empty walk-in closet with hangers and a folded robe on a stool",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b0087375-dd72-4517-b6c8-1e7f777ccdc8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019e898f-05d6-7389-9f2c-e294d0f868e6.webp",
      "image_media": {
        "alt_text": "Bathroom with white vanity, sink, mirror, toilet, and bathtub with shower curtain.",
        "public_id": "019e898f-05d6-7389-9f2c-e294d0f868e6",
        "storage_key": "property/5762658426945536/019e898f-05d6-7389-9f2c-e294d0f868e6.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Modern bathroom featuring a white vanity, sink, and toilet, complemented by a bathtub with a shower curtain and decorative wall art.",
      "link": "",
      "alt_text": "Bathroom with white vanity, sink, mirror, toilet, and bathtub with shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_39a318a5-9531-49bc-a9cd-cd4d717c72c7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019e898e-ff4a-7165-98ed-1950c0b85838.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, elliptical, rowing machine, and weight machine. Pool visible through window.",
        "public_id": "019e898e-ff4a-7165-98ed-1950c0b85838",
        "storage_key": "property/5762658426945536/019e898e-ff4a-7165-98ed-1950c0b85838.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center. Featuring cardio machines like treadmills and ellipticals, as well as weight training equipment. Enjoy a refreshing view of the pool while you work out.",
      "link": "",
      "alt_text": "Fitness center with treadmills, elliptical, rowing machine, and weight machine. Pool visible through window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7a83766d-5bc0-4cdf-8779-431d0516b374",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019e898e-e8c8-700c-a450-adafc80b7a12.webp",
      "image_media": {
        "alt_text": "Primary bedroom with king-size bed, neutral decor, and large window.",
        "public_id": "019e898e-e8c8-700c-a450-adafc80b7a12",
        "storage_key": "property/5762658426945536/019e898e-e8c8-700c-a450-adafc80b7a12.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Tour the spacious primary bedroom, featuring a comfortable king-size bed, plush bedding, and ample natural light from the large window. This inviting space offers a serene retreat.",
      "link": "",
      "alt_text": "Primary bedroom with king-size bed, neutral decor, and large window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a4c0546d-f586-46bb-8437-2b7f48d0584a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019e898e-e7d9-70de-af4b-43cd755e4cd5.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, nightstands, and a dresser.",
        "public_id": "019e898e-e7d9-70de-af4b-43cd755e4cd5",
        "storage_key": "property/5762658426945536/019e898e-e7d9-70de-af4b-43cd755e4cd5.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a king-size bed with plush bedding, decorative pillows, and a rustic wood headboard. Includes nightstands with lamps and a dresser with decorative items.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, nightstands, and a dresser.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_32fbcf45-162f-4b0c-9f48-26bc954a4f44",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019e898e-e885-779b-9e9d-f3e00cc3181d.webp",
      "image_media": {
        "alt_text": "Fitness center gym with weight racks, benches, medicine balls, and cardio equipment.",
        "public_id": "019e898e-e885-779b-9e9d-f3e00cc3181d",
        "storage_key": "property/5762658426945536/019e898e-e885-779b-9e9d-f3e00cc3181d.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Our state-of-the-art fitness center offers a full range of equipment for your workout needs.",
      "link": "",
      "alt_text": "Fitness center gym with weight racks, benches, medicine balls, and cardio equipment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d7538b66-c711-4a2a-b042-ed0511b7e6fb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019e898e-e826-72cb-88ca-3f7fbc63a324.webp",
      "image_media": {
        "alt_text": "Electric vehicle charging stations in the parking lot.",
        "public_id": "019e898e-e826-72cb-88ca-3f7fbc63a324",
        "storage_key": "property/5762658426945536/019e898e-e826-72cb-88ca-3f7fbc63a324.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Convenient electric vehicle charging stations available for residents, making it easy to power up your eco-friendly vehicle.",
      "link": "",
      "alt_text": "Electric vehicle charging stations in the parking lot.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ce93165e-89d0-4679-84f4-6a7771ea4625",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019e898e-e75d-70dc-8474-8a27ba02ca0b.webp",
      "image_media": {
        "alt_text": "Modern living room with a large sectional sofa, coffee table, and TV stand.",
        "public_id": "019e898e-e75d-70dc-8474-8a27ba02ca0b",
        "storage_key": "property/5762658426945536/019e898e-e75d-70dc-8474-8a27ba02ca0b.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Stylish living area featuring a comfortable sectional sofa, a rustic wooden coffee table, and a sleek entertainment center with a flat-screen TV.",
      "link": "",
      "alt_text": "Modern living room with a large sectional sofa, coffee table, and TV stand.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bd889fe0-0f64-482c-867a-c68f79546b7a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019e898e-e80b-71fd-8aee-bf36aee01818.webp",
      "image_media": {
        "alt_text": "Exterior view of a multi-story apartment building with blue siding and brick accents.",
        "public_id": "019e898e-e80b-71fd-8aee-bf36aee01818",
        "storage_key": "property/5762658426945536/019e898e-e80b-71fd-8aee-bf36aee01818.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Charming exterior of a multi-story apartment building featuring blue siding, brick accents, and well-maintained landscaping.",
      "link": "",
      "alt_text": "Exterior view of a multi-story apartment building with blue siding and brick accents.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_103b5ed0-b8d6-44d1-8527-5b333def7b76",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019e898e-e5f9-720c-95bd-965209a603cb.webp",
      "image_media": {
        "alt_text": "Washer and dryer in laundry closet with kitchen visible in background.",
        "public_id": "019e898e-e5f9-720c-95bd-965209a603cb",
        "storage_key": "property/5762658426945536/019e898e-e5f9-720c-95bd-965209a603cb.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Washer and dryer in a dedicated laundry closet, with a glimpse of a modern kitchen featuring white cabinets and a black refrigerator in the background.",
      "link": "",
      "alt_text": "Washer and dryer in laundry closet with kitchen visible in background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_298388ea-9af8-4fa6-8eb9-3829e0f59aa3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019e898e-e70d-72b3-8964-6185900b0b78.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool and hot tub with lounge chairs and umbrellas.",
        "public_id": "019e898e-e70d-72b3-8964-6185900b0b78",
        "storage_key": "property/5762658426945536/019e898e-e70d-72b3-8964-6185900b0b78.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy our sparkling swimming pool and relaxing hot tub, perfect for unwinding after a long day or spending time with friends and family.",
      "link": "",
      "alt_text": "Resort-style swimming pool and hot tub with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9a7b6f14-cad0-4a74-8390-1e8c1add6224",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019e898e-e72f-7076-ae55-25f40e1867bb.webp",
      "image_media": {
        "alt_text": "Modern kitchen and dining area with white cabinets, granite countertops, and a large wooden dining table.",
        "public_id": "019e898e-e72f-7076-ae55-25f40e1867bb",
        "storage_key": "property/5762658426945536/019e898e-e72f-7076-ae55-25f40e1867bb.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious kitchen and dining area featuring sleek white cabinetry, elegant granite countertops, and a rustic wooden dining set, perfect for entertaining.",
      "link": "",
      "alt_text": "Modern kitchen and dining area with white cabinets, granite countertops, and a large wooden dining table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_061244751fddc546468afc58",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "Panera Bread",
      "poi_type": "Restaurants",
      "poi_address": "8034 Concord Mills Boulevard, Concord, NC 28027, USA",
      "poi_short_description": "Counter-serve bakery/cafe chain serving sandwiches, salads & more, known for its bread & free WiFi.",
      "poi_long_description": "Counter-serve bakery/cafe chain serving sandwiches, salads & more, known for its bread & free WiFi.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150d-4cbb-7376-9c1c-cd75f13e6ff5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-4cbb-7376-9c1c-cd75f13e6ff5",
        "storage_key": "property/5762658426945536/019f150d-4cbb-7376-9c1c-cd75f13e6ff5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.panerabread.com/en-us/cafe/locations/nc/concord/8034-concord-mills-boulevard?utm_medium=local&utm_source=google&utm_campaign=dpm-dist&utm_term=600852&utm_content=main",
      "poi_directions_map_url": "https://maps.google.com/?cid=18415837774665755101&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "panera-bread",
      "poi_latitude": "35.3721891",
      "poi_longitude": "-80.7181363",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 704-979-1990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150e-1ee4-71c2-b10c-1b59c9c7e335.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-1ee4-71c2-b10c-1b59c9c7e335",
        "storage_key": "property/5762658426945536/019f150e-1ee4-71c2-b10c-1b59c9c7e335.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ36RwlFkbVIgR3SksgOIykv8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "ec_39d7cac6247ea3f7fbb49e2d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "Bonefish Grill",
      "poi_type": "Restaurants",
      "poi_address": "8503 Concord Mills Boulevard, Concord, NC 28027, USA",
      "poi_short_description": "Contemporary grill chain offering a seafood-centric menu, plus steaks & cocktails.",
      "poi_long_description": "Contemporary grill chain offering a seafood-centric menu, plus steaks & cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150d-604b-713f-adc3-f25d8ba49658.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-604b-713f-adc3-f25d8ba49658",
        "storage_key": "property/5762658426945536/019f150d-604b-713f-adc3-f25d8ba49658.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.bonefishgrill.com/north-carolina/concord-mills/8503-concord-mills-blvd?y_source=1_MTU1MDI4NTktNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=14029914822914293643&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bonefish-grill",
      "poi_latitude": "35.3706205",
      "poi_longitude": "-80.7219071",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 704-208-3618",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-471e-75d8-a52e-4b90e8767d73.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-471e-75d8-a52e-4b90e8767d73",
        "storage_key": "property/5762658426945536/019f150b-471e-75d8-a52e-4b90e8767d73.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJXaEK-accVIgRiz_LoDJFtMI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "ec_723588cf35cb6dbe0d5ec652",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "BJ's Restaurant & Brewhouse",
      "poi_type": "Restaurants",
      "poi_address": "Parking lot, 8435 Concord Mills Boulevard, Concord, NC 28027, USA",
      "poi_short_description": "Family-friendly chain outpost pairs familiar pub fare with an extensive list of house brews.",
      "poi_long_description": "Family-friendly chain outpost pairs familiar pub fare with an extensive list of house brews.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150d-49f4-701a-aca8-7ce02c3bc132.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-49f4-701a-aca8-7ce02c3bc132",
        "storage_key": "property/5762658426945536/019f150d-49f4-701a-aca8-7ce02c3bc132.webp",
        "width": 800,
        "height": 600
      },
      "poi_business_url": "https://www.bjsrestaurants.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17878522490247606685&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bjs-restaurant--brewhouse",
      "poi_latitude": "35.3702706",
      "poi_longitude": "-80.7210994",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 980-777-7030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-471e-75d8-a52e-4b90e8767d73.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-471e-75d8-a52e-4b90e8767d73",
        "storage_key": "property/5762658426945536/019f150b-471e-75d8-a52e-4b90e8767d73.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLW9LrCYbVIgRnXEK_HpFHfg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_dc5516a826544670e7be42c4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "Outback Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "8507 Concord Mills Boulevard, Concord, NC 28027, USA",
      "poi_short_description": "Boisterous Australian-themed chain serving steaks, seafood & other hearty steakhouse fare.",
      "poi_long_description": "Boisterous Australian-themed chain serving steaks, seafood & other hearty steakhouse fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150d-4cd3-7328-9321-dbfa1aef330a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-4cd3-7328-9321-dbfa1aef330a",
        "storage_key": "property/5762658426945536/019f150d-4cd3-7328-9321-dbfa1aef330a.webp",
        "width": 1280,
        "height": 876
      },
      "poi_business_url": "https://locations.outback.com/north-carolina/concord/8507-concord-mills-boulevard?utm_source=gmb&utm_medium=local_search&utm_campaign=website_cta&y_source=1_MTU1MDI2MjAtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=14313781975961620718&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "outback-steakhouse",
      "poi_latitude": "35.3709731",
      "poi_longitude": "-80.72274809999999",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 704-208-3619",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-471e-75d8-a52e-4b90e8767d73.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-471e-75d8-a52e-4b90e8767d73",
        "storage_key": "property/5762658426945536/019f150b-471e-75d8-a52e-4b90e8767d73.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJp0CD46ccVIgR7tCUld7EpMY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "ec_83f1f3753dcf433422b04a15",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "Dave & Buster's Concord",
      "poi_type": "Restaurants",
      "poi_address": "8361 Concord Mills Boulevard, Concord, NC 28027, USA",
      "poi_short_description": "Family-friendly chain offering a sports-bar-style setting for American food & arcade games.",
      "poi_long_description": "Family-friendly chain offering a sports-bar-style setting for American food & arcade games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150d-5f2b-70ce-b4f2-9cec25f712fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-5f2b-70ce-b4f2-9cec25f712fb",
        "storage_key": "property/5762658426945536/019f150d-5f2b-70ce-b4f2-9cec25f712fb.webp",
        "width": 1280,
        "height": 864
      },
      "poi_business_url": "https://www.daveandbusters.com/us/en/about/locations/concord",
      "poi_directions_map_url": "https://maps.google.com/?cid=6729695864119554056&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dave--busters-concord",
      "poi_latitude": "35.3711585",
      "poi_longitude": "-80.72406240000001",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 704-979-1700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-471e-75d8-a52e-4b90e8767d73.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-471e-75d8-a52e-4b90e8767d73",
        "storage_key": "property/5762658426945536/019f150b-471e-75d8-a52e-4b90e8767d73.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJP_zX36ccVIgRCPBCo7uuZF0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_d3807613986d39f2d669ded1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "Mac's Speed Shop",
      "poi_type": "Restaurants",
      "poi_address": "8021 Concord Mills Boulevard, Concord, NC 28027, USA",
      "poi_short_description": "Local restaurant & bar chain serving BBQ, burgers, wings, Southern fare & more, plus numerous beers.",
      "poi_long_description": "Local restaurant & bar chain serving BBQ, burgers, wings, Southern fare & more, plus numerous beers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150d-4b30-745a-b02e-5319324fbe5a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-4b30-745a-b02e-5319324fbe5a",
        "storage_key": "property/5762658426945536/019f150d-4b30-745a-b02e-5319324fbe5a.webp",
        "width": 820,
        "height": 614
      },
      "poi_business_url": "http://www.macspeedshop.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11179712194662730000&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "macs-speed-shop",
      "poi_latitude": "35.3700003",
      "poi_longitude": "-80.71733859999999",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 980-399-7400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-471e-75d8-a52e-4b90e8767d73.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-471e-75d8-a52e-4b90e8767d73",
        "storage_key": "property/5762658426945536/019f150b-471e-75d8-a52e-4b90e8767d73.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJUdZODmsbVIgREIn5JQJRJps",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "ec_7b6e4fc4ae0436177c2f88b2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "Poke n' Ramen 360",
      "poi_type": "Restaurants",
      "poi_address": "food court outlet 8111, Concord Mills Boulevard #240, Concord, NC 28027, USA",
      "poi_short_description": "Food-court sushi and ramen shop known for its poke bowls and bubble tea.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150d-5492-7753-92fa-0cff95043b05.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-5492-7753-92fa-0cff95043b05",
        "storage_key": "property/5762658426945536/019f150d-5492-7753-92fa-0cff95043b05.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.pokeramenconcord.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5005396853215794816&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "poke-n-ramen-360",
      "poi_latitude": "35.3696902",
      "poi_longitude": "-80.7230117",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 704-808-4821",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-471e-75d8-a52e-4b90e8767d73.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-471e-75d8-a52e-4b90e8767d73",
        "storage_key": "property/5762658426945536/019f150b-471e-75d8-a52e-4b90e8767d73.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJg4dGZNAFVIgRgBbJE-u9dkU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hawaiian_restaurant"
    },
    {
      "id": "ec_6ae2027c953ff45e1765c0e4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "Chipotle Mexican Grill",
      "poi_type": "Restaurants",
      "poi_address": "8509 Concord Mills Boulevard, Concord, NC 28027, USA",
      "poi_short_description": "Casual restaurant offering Mexican fare, including design-your-own burritos, tacos & bowls.",
      "poi_long_description": "Casual restaurant offering Mexican fare, including design-your-own burritos, tacos & bowls.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150d-5bf1-777a-b3df-8b698a117d5e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-5bf1-777a-b3df-8b698a117d5e",
        "storage_key": "property/5762658426945536/019f150d-5bf1-777a-b3df-8b698a117d5e.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "https://locations.chipotle.com/nc/concord/8509-concord-mills-blvd?utm_source=google&utm_medium=yext&utm_campaign=yext_listings?restaurant=2880",
      "poi_directions_map_url": "https://maps.google.com/?cid=5530670451655362274&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chipotle-mexican-grill",
      "poi_latitude": "35.3711263",
      "poi_longitude": "-80.7230246",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 704-971-6101",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-471e-75d8-a52e-4b90e8767d73.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-471e-75d8-a52e-4b90e8767d73",
        "storage_key": "property/5762658426945536/019f150b-471e-75d8-a52e-4b90e8767d73.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJp0CD46ccVIgR4saqGHnjwEw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_dfd3e65944be648f4c500a7d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "Salsarita's Fresh Mexican Grill",
      "poi_type": "Restaurants",
      "poi_address": "8111 Concord Mills Boulevard, Concord, NC 28027, USA",
      "poi_short_description": "Counter-serve Mexican chain offering customized burritos, nachos & quesadillas in a colorful space.",
      "poi_long_description": "Counter-serve Mexican chain offering customized burritos, nachos & quesadillas in a colorful space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150d-59f9-7050-a2a1-1fd0a5d683a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-59f9-7050-a2a1-1fd0a5d683a1",
        "storage_key": "property/5762658426945536/019f150d-59f9-7050-a2a1-1fd0a5d683a1.webp",
        "width": 1280,
        "height": 819
      },
      "poi_business_url": "https://salsaritas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5881933397242554931&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "salsaritas-fresh-mexican-grill",
      "poi_latitude": "35.36937",
      "poi_longitude": "-80.723247",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 704-979-9015",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-471e-75d8-a52e-4b90e8767d73.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-471e-75d8-a52e-4b90e8767d73",
        "storage_key": "property/5762658426945536/019f150b-471e-75d8-a52e-4b90e8767d73.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1eSGZqccVIgRMyomz0LToFE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_0f6b4af9644db1a5c85790eb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "Villa Italian Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "8111 Concord Mills Boulevard Ste FC07, Concord, NC 28027, USA",
      "poi_short_description": "Counter-serve pizza chain with traditional pies & slices, plus pasta & other Italian staples.",
      "poi_long_description": "Counter-serve pizza chain with traditional pies & slices, plus pasta & other Italian staples.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150d-4cb8-74f2-831c-d3612a4b92e7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-4cb8-74f2-831c-d3612a4b92e7",
        "storage_key": "property/5762658426945536/019f150d-4cb8-74f2-831c-d3612a4b92e7.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://locations.villaitaliankitchen.com/en-us/nc/concord/8111-concord-mills-blvd/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7059043548695052276&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "villa-italian-kitchen",
      "poi_latitude": "35.3700689",
      "poi_longitude": "-80.7239298",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 704-979-9015",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-471e-75d8-a52e-4b90e8767d73.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-471e-75d8-a52e-4b90e8767d73",
        "storage_key": "property/5762658426945536/019f150b-471e-75d8-a52e-4b90e8767d73.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9fhDZqccVIgR9D_7BbXC9mE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "ec_2ad1c083d351b3812bb2f0dd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "Sol' Delish",
      "poi_type": "Restaurants",
      "poi_address": "8927 J M Keynes Dr #100, Charlotte, NC 28262, USA",
      "poi_short_description": "Casual restaurant featuring Southern eats, including fried chicken and seafood, as well as cocktails and wine.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150d-59ae-70a9-8257-1f557a207e26.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-59ae-70a9-8257-1f557a207e26",
        "storage_key": "property/5762658426945536/019f150d-59ae-70a9-8257-1f557a207e26.webp",
        "width": 721,
        "height": 1280
      },
      "poi_business_url": "http://soldelish.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14251820301083844194&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sol-delish",
      "poi_latitude": "35.3092257",
      "poi_longitude": "-80.7492875",
      "poi_miles_from_property": "8.3 mi",
      "poi_walking_minutes": "3 hours 3 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 704-733-9430",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-471e-75d8-a52e-4b90e8767d73.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-471e-75d8-a52e-4b90e8767d73",
        "storage_key": "property/5762658426945536/019f150b-471e-75d8-a52e-4b90e8767d73.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJMSB6D-UdVIgRYp7N8A2jyMU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "soul_food_restaurant"
    },
    {
      "id": "ec_11d8829ebcef17951b899c15",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "Zapata's Mexican Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "8927 J M Keynes Dr, Charlotte, NC 28262, USA",
      "poi_short_description": "Family-family outpost serving generous portions of familiar Mexican plates in relaxed surrounds.",
      "poi_long_description": "Family-family outpost serving generous portions of familiar Mexican plates in relaxed surrounds.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150d-5ae0-746f-9a4a-42264a82e32f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-5ae0-746f-9a4a-42264a82e32f",
        "storage_key": "property/5762658426945536/019f150d-5ae0-746f-9a4a-42264a82e32f.webp",
        "width": 1280,
        "height": 590
      },
      "poi_business_url": "https://zapatasuniversity.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9505794243155199311&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "zapatas-mexican-restaurant",
      "poi_latitude": "35.3090293",
      "poi_longitude": "-80.7492867",
      "poi_miles_from_property": "8.3 mi",
      "poi_walking_minutes": "3 hours 3 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 704-503-1979",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-471e-75d8-a52e-4b90e8767d73.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-471e-75d8-a52e-4b90e8767d73",
        "storage_key": "property/5762658426945536/019f150b-471e-75d8-a52e-4b90e8767d73.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJucmkqSQcVIgRTwU4E4Bd64M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_07246ef8748f3efe7fd78261",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "Red Robin Gourmet Burgers and Brews",
      "poi_type": "Restaurants",
      "poi_address": "8304 Kenbrooke Dr, Charlotte, NC 28262, USA",
      "poi_short_description": "Chain for gourmet burgers & other American comfort fare.",
      "poi_long_description": "Chain for gourmet burgers & other American comfort fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150d-5941-73db-b6d9-32a4d7a32fab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-5941-73db-b6d9-32a4d7a32fab",
        "storage_key": "property/5762658426945536/019f150d-5941-73db-b6d9-32a4d7a32fab.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.redrobin.com/locations/nc/charlotte/harris-blvd-421",
      "poi_directions_map_url": "https://maps.google.com/?cid=10166319662064027858&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "red-robin-gourmet-burgers-and-brews",
      "poi_latitude": "35.3167976",
      "poi_longitude": "-80.77171059999999",
      "poi_miles_from_property": "7.3 mi",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 704-971-2060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-471e-75d8-a52e-4b90e8767d73.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-471e-75d8-a52e-4b90e8767d73",
        "storage_key": "property/5762658426945536/019f150b-471e-75d8-a52e-4b90e8767d73.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJOSnKrM4dVIgR0khlgt4FFo0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_8480e062c3c26efc5a164665",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "Flying Saucer Draught Emporium",
      "poi_type": "Restaurants",
      "poi_address": "9605 N Tryon St A, Charlotte, NC 28262, USA",
      "poi_short_description": "Chain taproom offering 200+ global beers & pub fare in tavernlike surroundings.",
      "poi_long_description": "Chain taproom offering 200+ global beers & pub fare in tavernlike surroundings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150d-595d-7088-b351-4dd6e266ffef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-595d-7088-b351-4dd6e266ffef",
        "storage_key": "property/5762658426945536/019f150d-595d-7088-b351-4dd6e266ffef.webp",
        "width": 1150,
        "height": 350
      },
      "poi_business_url": "http://www.beerknurd.com/locations/charlotte-flying-saucer",
      "poi_directions_map_url": "https://maps.google.com/?cid=2114554646901837938&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "flying-saucer-draught-emporium",
      "poi_latitude": "35.3167182",
      "poi_longitude": "-80.74052669999999",
      "poi_miles_from_property": "7.9 mi",
      "poi_walking_minutes": "2 hours 52 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 704-717-8179",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-471e-75d8-a52e-4b90e8767d73.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-471e-75d8-a52e-4b90e8767d73",
        "storage_key": "property/5762658426945536/019f150b-471e-75d8-a52e-4b90e8767d73.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJT-XTUxQcVIgRclC8ej9oWB0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_5d4f6a35ae5fe9fe93875631",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "Iron Dish Korean BBQ",
      "poi_type": "Restaurants",
      "poi_address": "9605 N Tryon St Suite H, Charlotte, NC 28262, USA",
      "poi_short_description": "Casual BBQ spot featuring marinated meats cooked tableside, plus a full bar.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150d-65b0-73fc-ad94-5ff86d9ba091.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-65b0-73fc-ad94-5ff86d9ba091",
        "storage_key": "property/5762658426945536/019f150d-65b0-73fc-ad94-5ff86d9ba091.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://irondishkoreanbbq.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8985347666583644909&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "iron-dish-korean-bbq",
      "poi_latitude": "35.3169549",
      "poi_longitude": "-80.74029019999999",
      "poi_miles_from_property": "7.9 mi",
      "poi_walking_minutes": "2 hours 52 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 980-225-7378",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-471e-75d8-a52e-4b90e8767d73.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-471e-75d8-a52e-4b90e8767d73",
        "storage_key": "property/5762658426945536/019f150b-471e-75d8-a52e-4b90e8767d73.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJL4NeKG0dVIgR7Woaqhhesnw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "korean_barbecue_restaurant"
    },
    {
      "id": "ec_ffec2dcaea15b47daf1f9d0b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "Lowes Foods of Concord",
      "poi_type": "Shopping & Retail",
      "poi_address": "2415 Herrons Nest Pl NW, Concord, NC 28027, USA",
      "poi_short_description": "Supermarket chain known for chicken prepared on-site, plus pantry staples, produce, bakery & more.",
      "poi_long_description": "Supermarket chain known for chicken prepared on-site, plus pantry staples, produce, bakery & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150d-6d89-75eb-87c5-3c0484fa7cdd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-6d89-75eb-87c5-3c0484fa7cdd",
        "storage_key": "property/5762658426945536/019f150d-6d89-75eb-87c5-3c0484fa7cdd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.lowesfoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8054174508725485783&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lowes-foods-of-concord",
      "poi_latitude": "35.3799249",
      "poi_longitude": "-80.73553369999999",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 980-399-2093",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-470a-7258-9fdf-4b6bc8628a28.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-470a-7258-9fdf-4b6bc8628a28",
        "storage_key": "property/5762658426945536/019f150b-470a-7258-9fdf-4b6bc8628a28.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJD-zfAyodVIgR18CW9wotxm8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_f8212cd6f2c573760d1f2cc2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "Dollar Tree",
      "poi_type": "Shopping & Retail",
      "poi_address": "8074 Concord Mills Boulevard, Concord, NC 28027, USA",
      "poi_short_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_long_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150d-6294-7679-88d4-46cd4d7eeb40.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-6294-7679-88d4-46cd4d7eeb40",
        "storage_key": "property/5762658426945536/019f150d-6294-7679-88d4-46cd4d7eeb40.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://locations.dollartree.com/nc/concord/8074-concord-mills-blvd?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=17500408772714300909&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-tree",
      "poi_latitude": "35.3727089",
      "poi_longitude": "-80.7144871",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 980-866-4751",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-4743-73b8-b476-6e22a3073eca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-4743-73b8-b476-6e22a3073eca",
        "storage_key": "property/5762658426945536/019f150b-4743-73b8-b476-6e22a3073eca.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJSyKNk1kbVIgR7QXEwQ7x3fI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "ec_91a646e1c610809712d088d8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "Petco",
      "poi_type": "Shopping & Retail",
      "poi_address": "8070 Concord Mills Boulevard, Concord, NC 28027, USA",
      "poi_short_description": "Chain with pet food & supplies such as toys, beds & pet technology products, plus medication.",
      "poi_long_description": "Chain with pet food & supplies such as toys, beds & pet technology products, plus medication.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150d-73ce-74df-9031-7ca7cdd74988.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-73ce-74df-9031-7ca7cdd74988",
        "storage_key": "property/5762658426945536/019f150d-73ce-74df-9031-7ca7cdd74988.webp",
        "width": 1280,
        "height": 1023
      },
      "poi_business_url": "https://stores.petco.com/nc/concord/pet-supplies-concord-nc-2737.html?utm_source=google&utm_campaign=locallist_2737_pcc",
      "poi_directions_map_url": "https://maps.google.com/?cid=13836156468058545594&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "petco",
      "poi_latitude": "35.3726675",
      "poi_longitude": "-80.714795",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 704-979-1952",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-4743-73b8-b476-6e22a3073eca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-4743-73b8-b476-6e22a3073eca",
        "storage_key": "property/5762658426945536/019f150b-4743-73b8-b476-6e22a3073eca.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJSyKNk1kbVIgRul1aJwDnA8A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pet_store"
    },
    {
      "id": "ec_109c4624aa71a7b72fc8b742",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "5230 Poplar Tent Rd, Concord, NC 28027, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150d-8363-71c1-8296-a2b3976219f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-8363-71c1-8296-a2b3976219f2",
        "storage_key": "property/5762658426945536/019f150d-8363-71c1-8296-a2b3976219f2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-5230+poplar+tent+rd-concord-nc-28027/id=7767",
      "poi_directions_map_url": "https://maps.google.com/?cid=18422075148058255160&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "35.4134774",
      "poi_longitude": "-80.6662077",
      "poi_miles_from_property": "7.0 mi",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 704-784-1977",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-470b-74cd-afe9-1fb2484c1439.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-470b-74cd-afe9-1fb2484c1439",
        "storage_key": "property/5762658426945536/019f150b-470b-74cd-afe9-1fb2484c1439.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJW8vrYAUFVIgROF-QKb5bqP8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_3998476465c48be1b8d791b4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "Michaels",
      "poi_type": "Shopping & Retail",
      "poi_address": "Pavilion at King's Grant, 8066 Concord Mills Boulevard, Concord, NC 28027, USA",
      "poi_short_description": "Chain retailer carrying art & hobby supplies plus home decor (most offer classes & custom framing).",
      "poi_long_description": "Chain retailer carrying art & hobby supplies plus home decor (most offer classes & custom framing).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150d-71f4-728e-9e4f-f753cd7fdd74.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-71f4-728e-9e4f-f753cd7fdd74",
        "storage_key": "property/5762658426945536/019f150d-71f4-728e-9e4f-f753cd7fdd74.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.michaels.com/NC/Concord/1389/?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=16076159104692973688&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "michaels",
      "poi_latitude": "35.3727451",
      "poi_longitude": "-80.71511799999999",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 704-579-6939",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-4743-73b8-b476-6e22a3073eca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-4743-73b8-b476-6e22a3073eca",
        "storage_key": "property/5762658426945536/019f150b-4743-73b8-b476-6e22a3073eca.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJcxai2ocbVIgRePDi04f9Gd8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "ec_fca942f12359890d07f84b86",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "DSW Designer Shoe Warehouse",
      "poi_type": "Shopping & Retail",
      "poi_address": "8088 Concord Mills Boulevard, Concord, NC 28027, USA",
      "poi_short_description": "Retail chain known for its discounted brand-name & designer shoes, handbags & accessories.",
      "poi_long_description": "Retail chain known for its discounted brand-name & designer shoes, handbags & accessories.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150d-788c-7093-92af-ceb65faa1d0a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-788c-7093-92af-ceb65faa1d0a",
        "storage_key": "property/5762658426945536/019f150d-788c-7093-92af-ceb65faa1d0a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.dsw.com/usa/nc/concord/dsw-designer-shoe-warehouse-pavilion---kings-grant.html?y_source=1_MTY1MTY4My03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=13325204342470718678&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dsw-designer-shoe-warehouse",
      "poi_latitude": "35.3724604",
      "poi_longitude": "-80.71344669999999",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 704-665-5306",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-4743-73b8-b476-6e22a3073eca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-4743-73b8-b476-6e22a3073eca",
        "storage_key": "property/5762658426945536/019f150b-4743-73b8-b476-6e22a3073eca.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJSyKNk1kbVIgR1rR14L-i7Lg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shoe_store"
    },
    {
      "id": "ec_e1d1d0e2cbed4da907a7840d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "8670 Concord Mills Boulevard, Concord, NC 28027, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150d-78f0-7437-8e83-72837117dbf0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-78f0-7437-8e83-72837117dbf0",
        "storage_key": "property/5762658426945536/019f150d-78f0-7437-8e83-72837117dbf0.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.lowes.com/store/NC-Concord/2981?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-2981-_-na-_-0-_-0&y_source=1_MTE4MzgzMy03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=1312447763250149975&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "35.375679",
      "poi_longitude": "-80.728931",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 704-652-4500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-4743-73b8-b476-6e22a3073eca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-4743-73b8-b476-6e22a3073eca",
        "storage_key": "property/5762658426945536/019f150b-4743-73b8-b476-6e22a3073eca.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJI00NG68cVIgRV_rHeknANhI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "ec_325dd9bef7dda8651e06962e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "5825 Thunder Rd NW, Concord, NC 28027, USA",
      "poi_short_description": "Department store offering grocery items, electronics, home goods and clothing along with a self checkout.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150d-8437-75e8-a780-2f545c746a6d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-8437-75e8-a780-2f545c746a6d",
        "storage_key": "property/5762658426945536/019f150d-8437-75e8-a780-2f545c746a6d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walmart.com/store/4574-concord-nc/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=7627622230872196852&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "35.3786689",
      "poi_longitude": "-80.7247333",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 704-979-2540",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-4743-73b8-b476-6e22a3073eca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-4743-73b8-b476-6e22a3073eca",
        "storage_key": "property/5762658426945536/019f150b-4743-73b8-b476-6e22a3073eca.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ8xdDfKkcVIgR9IYCkAHC2mk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_386ccf948b2bb3abd8eaa92f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "Concord Mills",
      "poi_type": "Shopping & Retail",
      "poi_address": "8111 Concord Mills Boulevard, Concord, NC 28027, USA",
      "poi_short_description": "Large mall with mostly outlet & big-box stores, plus a movie theater, restaurants & an aquarium.",
      "poi_long_description": "Large mall with mostly outlet & big-box stores, plus a movie theater, restaurants & an aquarium.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-1085-70d9-8010-465933c04d62.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-1085-70d9-8010-465933c04d62",
        "storage_key": "property/5762658426945536/019f150b-1085-70d9-8010-465933c04d62.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.simon.com/mall/concord-mills",
      "poi_directions_map_url": "https://maps.google.com/?cid=15278858876011446672&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "concord-mills",
      "poi_latitude": "35.3690086",
      "poi_longitude": "-80.72197059999999",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 704-886-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-4743-73b8-b476-6e22a3073eca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-4743-73b8-b476-6e22a3073eca",
        "storage_key": "property/5762658426945536/019f150b-4743-73b8-b476-6e22a3073eca.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJpU5jZKccVIgRkIH8ZTJpCdQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_725b796191590f4b70e41e94",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "Bass Pro Shops",
      "poi_type": "Shopping & Retail",
      "poi_address": "8181 Concord Mills Boulevard, Concord, NC 28027, USA",
      "poi_short_description": "Chain known for its large, wilderness-themed stores & wide array of hunting, fishing & outdoor gear.",
      "poi_long_description": "Chain known for its large, wilderness-themed stores & wide array of hunting, fishing & outdoor gear.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150d-8c6d-721a-a1f6-3c20f6e76bfe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-8c6d-721a-a1f6-3c20f6e76bfe",
        "storage_key": "property/5762658426945536/019f150d-8c6d-721a-a1f6-3c20f6e76bfe.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.basspro.com/us/nc/concord/8181-concord-mills-blvd.html?y_source=1_MzAxMTQ5OC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=4436789771853565545&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bass-pro-shops",
      "poi_latitude": "35.3672812",
      "poi_longitude": "-80.7191974",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 704-979-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-4743-73b8-b476-6e22a3073eca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-4743-73b8-b476-6e22a3073eca",
        "storage_key": "property/5762658426945536/019f150b-4743-73b8-b476-6e22a3073eca.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJSamihlkbVIgRaQ5rVsqkkj0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sporting_goods_store"
    },
    {
      "id": "ec_69c305f2be63ebf65c8687ed",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "Mallard Creek Elementary School",
      "poi_type": "Education",
      "poi_address": "9801 Mallard Creek Rd, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150d-9a7b-75d8-bb5e-5d189aa49773.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-9a7b-75d8-bb5e-5d189aa49773",
        "storage_key": "property/5762658426945536/019f150d-9a7b-75d8-bb5e-5d189aa49773.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cmsk12.org/mallardcreekES",
      "poi_directions_map_url": "https://maps.google.com/?cid=9511436041936188988&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mallard-creek-elementary-school",
      "poi_latitude": "35.3354412",
      "poi_longitude": "-80.7741362",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 980-343-3980",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-4707-762f-9b0e-8d0ca04144e3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-4707-762f-9b0e-8d0ca04144e3",
        "storage_key": "property/5762658426945536/019f150b-4707-762f-9b0e-8d0ca04144e3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJV3xM6uscVIgRPDZ0t69o_4M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_739c9529b6bf8a7d7ba45842",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "Stoney Creek Elementary School",
      "poi_type": "Education",
      "poi_address": "14015 Mallard Roost Rd, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150d-8b30-754c-8325-793dd832802c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-8b30-754c-8325-793dd832802c",
        "storage_key": "property/5762658426945536/019f150d-8b30-754c-8325-793dd832802c.webp",
        "width": 1200,
        "height": 570
      },
      "poi_business_url": "https://www.cmsk12.org/stoneycreekES",
      "poi_directions_map_url": "https://maps.google.com/?cid=16947952449494394279&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stoney-creek-elementary-school",
      "poi_latitude": "35.3482805",
      "poi_longitude": "-80.7253375",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 980-344-1030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-4707-762f-9b0e-8d0ca04144e3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-4707-762f-9b0e-8d0ca04144e3",
        "storage_key": "property/5762658426945536/019f150b-4707-762f-9b0e-8d0ca04144e3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJq8y7u4McVIgRpyVTbvU4M-s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_541edf4aea8ceabda3462c8e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "Ridge Road Middle School",
      "poi_type": "Education",
      "poi_address": "7260 Highland Creek Pkwy, Charlotte, NC 28269, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.cmsk12.org/ridgeroadMS",
      "poi_directions_map_url": "https://maps.google.com/?cid=1281427930266189462&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ridge-road-middle-school",
      "poi_latitude": "35.37623500000001",
      "poi_longitude": "-80.76235400000002",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 980-344-3410",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-4707-762f-9b0e-8d0ca04144e3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-4707-762f-9b0e-8d0ca04144e3",
        "storage_key": "property/5762658426945536/019f150b-4707-762f-9b0e-8d0ca04144e3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJO8lKEtccVIgRlr7HzOmLyBE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_c531dc4ccb7b6379666fdfb1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "Mallard Creek High School",
      "poi_type": "Education",
      "poi_address": "3825 Johnston Oehler Rd, Charlotte, NC 28269, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150d-8c6d-721a-a1f6-39fb372e6fc7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-8c6d-721a-a1f6-39fb372e6fc7",
        "storage_key": "property/5762658426945536/019f150d-8c6d-721a-a1f6-39fb372e6fc7.webp",
        "width": 1024,
        "height": 683
      },
      "poi_business_url": "https://www.cmsk12.org/mallardcreekHS",
      "poi_directions_map_url": "https://maps.google.com/?cid=6531472597723805118&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mallard-creek-high-school",
      "poi_latitude": "35.36517",
      "poi_longitude": "-80.76934159999999",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 980-343-1341",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-4707-762f-9b0e-8d0ca04144e3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-4707-762f-9b0e-8d0ca04144e3",
        "storage_key": "property/5762658426945536/019f150b-4707-762f-9b0e-8d0ca04144e3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQx6peB8dVIgRvnWG77hzpFo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_9fe2f2585e1db154c811bf63",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "Bradford Preparatory School",
      "poi_type": "Education",
      "poi_address": "2502 State Rd 2469, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150d-aaf2-71e7-8660-cc1ae54638ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-aaf2-71e7-8660-cc1ae54638ea",
        "storage_key": "property/5762658426945536/019f150d-aaf2-71e7-8660-cc1ae54638ea.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.bradfordprep.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13541386437304560903&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bradford-preparatory-school",
      "poi_latitude": "35.3456415",
      "poi_longitude": "-80.7213251",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 704-549-0080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-4707-762f-9b0e-8d0ca04144e3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-4707-762f-9b0e-8d0ca04144e3",
        "storage_key": "property/5762658426945536/019f150b-4707-762f-9b0e-8d0ca04144e3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFwbb_30bVIgRB63UKTir7Ls",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_d90fe35b11cc5da9ce7b45e7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "Kiddie Academy of Charlotte-Highlands",
      "poi_type": "Education",
      "poi_address": "3015 Warner Gln Dr, Charlotte, NC 28269, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150d-9f42-7740-99a9-3ff76362d1ff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-9f42-7740-99a9-3ff76362d1ff",
        "storage_key": "property/5762658426945536/019f150d-9f42-7740-99a9-3ff76362d1ff.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://kiddieacademy.com/academies/charlotte-highlands/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13606354867860590096&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kiddie-academy-of-charlotte-highlands",
      "poi_latitude": "35.367085",
      "poi_longitude": "-80.76920539999999",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 980-357-5437",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-4707-762f-9b0e-8d0ca04144e3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-4707-762f-9b0e-8d0ca04144e3",
        "storage_key": "property/5762658426945536/019f150b-4707-762f-9b0e-8d0ca04144e3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-VECXiUdVIgREM68qql707w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_0a21e1669acdf6f8b9ea2312",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "University Child Development",
      "poi_type": "Education",
      "poi_address": "6025 Clarke Creek Pkwy, Charlotte, NC 28269, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150d-a8a4-75bf-98b4-608ee084bf32.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-a8a4-75bf-98b4-608ee084bf32",
        "storage_key": "property/5762658426945536/019f150d-a8a4-75bf-98b4-608ee084bf32.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://universitycdc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=139083070723710189&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-child-development",
      "poi_latitude": "35.3885915",
      "poi_longitude": "-80.7557288",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 704-875-3338",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-4707-762f-9b0e-8d0ca04144e3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-4707-762f-9b0e-8d0ca04144e3",
        "storage_key": "property/5762658426945536/019f150b-4707-762f-9b0e-8d0ca04144e3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZ4guci0DVIgR7dzB4FAf7gE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_4515f7bb687b60991fb38735",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "University of North Carolina at Charlotte",
      "poi_type": "Education",
      "poi_address": "9201 University City Blvd, Charlotte, NC 28223, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-17d8-779c-9f98-8352524e166c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-17d8-779c-9f98-8352524e166c",
        "storage_key": "property/5762658426945536/019f150b-17d8-779c-9f98-8352524e166c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.charlotte.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7728009800198595827&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-north-carolina-at-charlotte",
      "poi_latitude": "35.3074169",
      "poi_longitude": "-80.73521219999999",
      "poi_miles_from_property": "8.6 mi",
      "poi_walking_minutes": "3 hours 9 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 704-687-8622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-4707-762f-9b0e-8d0ca04144e3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-4707-762f-9b0e-8d0ca04144e3",
        "storage_key": "property/5762658426945536/019f150b-4707-762f-9b0e-8d0ca04144e3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJVyOp0BocVIgR8yST8fdnP2s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_209f97327ee354efe9a731e6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "Rowan-Cabarrus Community College",
      "poi_type": "Education",
      "poi_address": "1531 Trinity Church Rd, Concord, NC 28027, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150d-b3d0-7369-aa98-273e8ce472e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-b3d0-7369-aa98-273e8ce472e8",
        "storage_key": "property/5762658426945536/019f150d-b3d0-7369-aa98-273e8ce472e8.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.rccc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14729629873731745231&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rowan-cabarrus-community-college",
      "poi_latitude": "35.4375622",
      "poi_longitude": "-80.659584",
      "poi_miles_from_property": "8.3 mi",
      "poi_walking_minutes": "3 hours 4 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 704-216-7222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-4707-762f-9b0e-8d0ca04144e3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-4707-762f-9b0e-8d0ca04144e3",
        "storage_key": "property/5762658426945536/019f150b-4707-762f-9b0e-8d0ca04144e3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJ9fzD7wFVIgRzzXDSFQoasw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_045093a93e3c3b6e920c4b8f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "Cabarrus College of Health Sciences",
      "poi_type": "Education",
      "poi_address": "401 Medical Park Dr NE, Concord, NC 28025, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150d-9f9e-71ce-84c2-d8d8d4e018c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-9f9e-71ce-84c2-d8d8d4e018c1",
        "storage_key": "property/5762658426945536/019f150d-9f9e-71ce-84c2-d8d8d4e018c1.webp",
        "width": 667,
        "height": 667
      },
      "poi_business_url": "https://cabarruscollege.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1386404138424524097&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cabarrus-college-of-health-sciences",
      "poi_latitude": "35.439955",
      "poi_longitude": "-80.60091150000001",
      "poi_miles_from_property": "12.4 mi",
      "poi_walking_minutes": "4 hours 36 mins",
      "poi_biking_minutes": "1 hour 7 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 704-403-1555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-4707-762f-9b0e-8d0ca04144e3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-4707-762f-9b0e-8d0ca04144e3",
        "storage_key": "property/5762658426945536/019f150b-4707-762f-9b0e-8d0ca04144e3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ3xmozxcPVIgRQd3s6Td_PRM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_7eb504b83dbefabafded14d7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "SEA LIFE Charlotte-Concord",
      "poi_type": "Entertainment",
      "poi_address": "8111 Concord Mills Boulevard, Concord, NC 28027, USA",
      "poi_short_description": "Family-friendly exhibits with a variety of sea creatures (most offer play areas & group packages).",
      "poi_long_description": "Family-friendly exhibits with a variety of sea creatures (most offer play areas & group packages).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-19da-70ba-831a-66291fdc9f77.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-19da-70ba-831a-66291fdc9f77",
        "storage_key": "property/5762658426945536/019f150b-19da-70ba-831a-66291fdc9f77.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.visitsealife.com/charlotte-concord/?utm_source=local-listing&utm_medium=organic&utm_campaign=tickets",
      "poi_directions_map_url": "https://maps.google.com/?cid=7728186963408053643&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sea-life-charlotte-concord",
      "poi_latitude": "35.3692328",
      "poi_longitude": "-80.72510779999999",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 704-456-1955",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-470b-74cd-afe9-1fb2484c1439.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-470b-74cd-afe9-1fb2484c1439",
        "storage_key": "property/5762658426945536/019f150b-470b-74cd-afe9-1fb2484c1439.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJR0LDIaccVIgRi-W99xgJQGs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "ec_a6d29c83d01a263b0cd14424",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "AMC Concord Mills 24",
      "poi_type": "Entertainment",
      "poi_address": "8421 Concord Mills Boulevard, Concord, NC 28027, USA",
      "poi_short_description": "Comfortable, clean screening rooms at the mall location of this popular theater chain.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150d-b457-7434-8733-7bfe71c1e846.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-b457-7434-8733-7bfe71c1e846",
        "storage_key": "property/5762658426945536/019f150d-b457-7434-8733-7bfe71c1e846.webp",
        "width": 1280,
        "height": 911
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/charlotte/amc-concord-mills-24?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=17290551946530007973&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-concord-mills-24",
      "poi_latitude": "35.3703321",
      "poi_longitude": "-80.7260192",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 704-979-0200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150e-1ee2-729a-9318-c9b89447ead3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-1ee2-729a-9318-c9b89447ead3",
        "storage_key": "property/5762658426945536/019f150e-1ee2-729a-9318-c9b89447ead3.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJJeT6YqYcVIgRpStc12Jh9O8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_2b490eb71d25990181cd1886",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "Dave & Buster's Concord",
      "poi_type": "Entertainment",
      "poi_address": "8361 Concord Mills Boulevard, Concord, NC 28027, USA",
      "poi_short_description": "Family-friendly chain offering a sports-bar-style setting for American food & arcade games.",
      "poi_long_description": "Family-friendly chain offering a sports-bar-style setting for American food & arcade games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150d-5f2b-70ce-b4f2-9cec25f712fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-5f2b-70ce-b4f2-9cec25f712fb",
        "storage_key": "property/5762658426945536/019f150d-5f2b-70ce-b4f2-9cec25f712fb.webp",
        "width": 1280,
        "height": 864
      },
      "poi_business_url": "https://www.daveandbusters.com/us/en/about/locations/concord",
      "poi_directions_map_url": "https://maps.google.com/?cid=6729695864119554056&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dave--busters-concord",
      "poi_latitude": "35.3711585",
      "poi_longitude": "-80.72406240000001",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 704-979-1700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-471e-75d8-a52e-4b90e8767d73.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-471e-75d8-a52e-4b90e8767d73",
        "storage_key": "property/5762658426945536/019f150b-471e-75d8-a52e-4b90e8767d73.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJP_zX36ccVIgRCPBCo7uuZF0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_8788e485e339103cebe5b109",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "Charlotte Motor Speedway",
      "poi_type": "Entertainment",
      "poi_address": "5555 Concord Pkwy S, Concord, NC 28027, USA",
      "poi_short_description": "Iconic NASCAR racetrack in a 95,000-seat stadium, with separate drag-racing & dirt tracks.",
      "poi_long_description": "Iconic NASCAR racetrack in a 95,000-seat stadium, with separate drag-racing & dirt tracks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150d-b36f-74de-be82-546f6ab05f89.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-b36f-74de-be82-546f6ab05f89",
        "storage_key": "property/5762658426945536/019f150d-b36f-74de-be82-546f6ab05f89.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.charlottemotorspeedway.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3877864903075356639&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "charlotte-motor-speedway",
      "poi_latitude": "35.3526259",
      "poi_longitude": "-80.6856586",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 800-455-3267",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-470b-74cd-afe9-1fb2484c1439.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-470b-74cd-afe9-1fb2484c1439",
        "storage_key": "property/5762658426945536/019f150b-470b-74cd-afe9-1fb2484c1439.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi8sDiRsbVIgR39_CYpXx0DU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "race_course"
    },
    {
      "id": "ec_6d63b0bad2c01bf271e5d3ce",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "Carowinds",
      "poi_type": "Entertainment",
      "poi_address": "North Carolina, USA",
      "poi_short_description": "Seasonal, family-friendly amusement park featuring towering roller coasters, waterslides & more.",
      "poi_long_description": "Seasonal, family-friendly amusement park featuring towering roller coasters, waterslides & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150d-b8f6-727e-bf79-25bc6c1e2a10.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-b8f6-727e-bf79-25bc6c1e2a10",
        "storage_key": "property/5762658426945536/019f150d-b8f6-727e-bf79-25bc6c1e2a10.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.carowinds.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3638331865982573054&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carowinds",
      "poi_latitude": "35.1024013",
      "poi_longitude": "-80.9412735",
      "poi_miles_from_property": "26.9 mi",
      "poi_walking_minutes": "9 hours 56 mins",
      "poi_biking_minutes": "2 hours 28 mins",
      "poi_driving_minutes": "34 mins",
      "poi_business_phone": "+1 704-588-2600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-470b-74cd-afe9-1fb2484c1439.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-470b-74cd-afe9-1fb2484c1439",
        "storage_key": "property/5762658426945536/019f150b-470b-74cd-afe9-1fb2484c1439.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLVWj3q-PVogR_hngLo7zfTI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "ec_207101f45785c9d528cd7470",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "Great Wolf Lodge | Concord",
      "poi_type": "Entertainment",
      "poi_address": "10175 Weddington Rd, Concord, NC 28027, USA",
      "poi_short_description": "Themed suites in a sprawling resort with free passes to the indoor water park plus kids' activities.",
      "poi_long_description": "Themed suites in a sprawling resort with free passes to the indoor water park plus kids' activities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150d-ba26-771d-badd-755062e34cfa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-ba26-771d-badd-755062e34cfa",
        "storage_key": "property/5762658426945536/019f150d-ba26-771d-badd-755062e34cfa.webp",
        "width": 1280,
        "height": 803
      },
      "poi_business_url": "https://www.greatwolf.com/concord?utm_source=google&utm_medium=organic&utm_campaign=gmb-concord",
      "poi_directions_map_url": "https://maps.google.com/?cid=1176379236566889740&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "great-wolf-lodge--concord",
      "poi_latitude": "35.3613868",
      "poi_longitude": "-80.71172729999999",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 866-925-9653",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150e-1ee0-76f9-9902-60b1c5e4ffb9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-1ee0-76f9-9902-60b1c5e4ffb9",
        "storage_key": "property/5762658426945536/019f150e-1ee0-76f9-9902-60b1c5e4ffb9.webp",
        "width": 192,
        "height": 122
      },
      "poi_google_place_id": "ChIJm6Y9Xl0bVIgRDPW21K5WUxA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "resort_hotel"
    },
    {
      "id": "ec_918100f47c262d6bf53cddb9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "iFLY Indoor Skydiving - Charlotte",
      "poi_type": "Entertainment",
      "poi_address": "7840 Lyles Ln NW, Concord, NC 28027, USA",
      "poi_short_description": "Chain facility for simulated skydiving with an indoor wind tunnel for flights and parties.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150d-b111-71af-b502-497726c91013.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-b111-71af-b502-497726c91013",
        "storage_key": "property/5762658426945536/019f150d-b111-71af-b502-497726c91013.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.iflyworld.com/charlotte/?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=14657549381427685251&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ifly-indoor-skydiving---charlotte",
      "poi_latitude": "35.366276",
      "poi_longitude": "-80.714287",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 704-851-4359",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-470b-74cd-afe9-1fb2484c1439.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-470b-74cd-afe9-1fb2484c1439",
        "storage_key": "property/5762658426945536/019f150b-470b-74cd-afe9-1fb2484c1439.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDdEUzJkbVIgRg2e-3YATass",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    },
    {
      "id": "ec_9e5a5cf81cb58d42bdda0b55",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "K1 Speed Concord",
      "poi_type": "Entertainment",
      "poi_address": "800 Derita Rd #K, Concord, NC 28027, USA",
      "poi_short_description": "Chain of indoor racing centers featuring electric go-karting for all skill levels, plus food.",
      "poi_long_description": "Chain of indoor racing centers featuring electric go-karting for all skill levels, plus food.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150d-b515-727b-add3-dea71616f812.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-b515-727b-add3-dea71616f812",
        "storage_key": "property/5762658426945536/019f150d-b515-727b-add3-dea71616f812.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://k1speed.com/concord-location.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=14043036545227898395&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "k1-speed-concord",
      "poi_latitude": "35.4037384",
      "poi_longitude": "-80.71535",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 704-490-4771",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-470b-74cd-afe9-1fb2484c1439.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-470b-74cd-afe9-1fb2484c1439",
        "storage_key": "property/5762658426945536/019f150b-470b-74cd-afe9-1fb2484c1439.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT3ENhqAEVIgRGz4jrlXj4sI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "ec_5510031af6d0e1c28c00fffa",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "Morrison Motor Car Museum",
      "poi_type": "Entertainment",
      "poi_address": "4545 Concord Pkwy S, Concord, NC 28027, USA",
      "poi_short_description": "Vintage & antique vehicles plus racing memorabilia showcased in a roomy space with a gift shop.",
      "poi_long_description": "Vintage & antique vehicles plus racing memorabilia showcased in a roomy space with a gift shop.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150d-c1e2-7096-b720-8b407f23446f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-c1e2-7096-b720-8b407f23446f",
        "storage_key": "property/5762658426945536/019f150d-c1e2-7096-b720-8b407f23446f.webp",
        "width": 822,
        "height": 463
      },
      "poi_business_url": "http://www.morrisonmotorcarmuseum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16796046795715783080&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "morrison-motor-car-museum",
      "poi_latitude": "35.3590299",
      "poi_longitude": "-80.6738745",
      "poi_miles_from_property": "5.7 mi",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 704-788-9500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150e-1ee6-752b-a653-2d0f3545ac26.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-1ee6-752b-a653-2d0f3545ac26",
        "storage_key": "property/5762658426945536/019f150e-1ee6-752b-a653-2d0f3545ac26.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4yhyLt4aVIgRqCl6SZKLF-k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_88c7e479a771b464470331db",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "Mustang Owner's Museum",
      "poi_type": "Entertainment",
      "poi_address": "4001 Dearborn Pl NW, Concord, NC 28027, USA",
      "poi_short_description": "A collection, featuring Mustangs, muscle cars, memorabilia and exhibits about Ford's iconic sports model.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150d-c3a0-7241-8c09-c526ed7c78f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-c3a0-7241-8c09-c526ed7c78f6",
        "storage_key": "property/5762658426945536/019f150d-c3a0-7241-8c09-c526ed7c78f6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mustangownersmuseum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4280425307018293527&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mustang-owners-museum",
      "poi_latitude": "35.3669221",
      "poi_longitude": "-80.671039",
      "poi_miles_from_property": "6.3 mi",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 980-439-5653",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150e-1ee6-752b-a653-2d0f3545ac26.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-1ee6-752b-a653-2d0f3545ac26",
        "storage_key": "property/5762658426945536/019f150e-1ee6-752b-a653-2d0f3545ac26.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJJTKuydsaVIgRF_FqWCMgZzs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_edbabd14ac54c5f409d6d668",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "Atrium Health Cabarrus",
      "poi_type": "Health and Wellness",
      "poi_address": "920 Church St N, Concord, NC 28025, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150d-cc29-73ee-9081-c9817584fafd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-cc29-73ee-9081-c9817584fafd",
        "storage_key": "property/5762658426945536/019f150d-cc29-73ee-9081-c9817584fafd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://atriumhealth.org/locations/atrium-health-cabarrus?utm_source=GMB&utm_medium=Organic&utm_campaign=GCR",
      "poi_directions_map_url": "https://maps.google.com/?cid=1622612822891421659&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "atrium-health-cabarrus",
      "poi_latitude": "35.4366428",
      "poi_longitude": "-80.6020008",
      "poi_miles_from_property": "12.3 mi",
      "poi_walking_minutes": "4 hours 32 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 704-403-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-4707-762f-9b0e-92252b7ffc81.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-4707-762f-9b0e-92252b7ffc81",
        "storage_key": "property/5762658426945536/019f150b-4707-762f-9b0e-92252b7ffc81.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJeXV8txcPVIgR299v9MOthBY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_61d9a5285d4b4b37987f46c4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "Atrium Health Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "8815 Christenbury Pkwy Ste 30, Concord, NC 28027, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150d-c64e-7107-adea-69e1b10ba14a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-c64e-7107-adea-69e1b10ba14a",
        "storage_key": "property/5762658426945536/019f150d-c64e-7107-adea-69e1b10ba14a.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://atriumhealth.org/locations/detail/atrium-health-urgent-care-concord-mills?utm_source=GMB&utm_medium=Organic&utm_campaign=GCR",
      "poi_directions_map_url": "https://maps.google.com/?cid=10836174592029502111&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "atrium-health-urgent-care",
      "poi_latitude": "35.3747103",
      "poi_longitude": "-80.73136629999999",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 704-403-8810",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-470b-74cd-afe9-1fb2484c1439.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-470b-74cd-afe9-1fb2484c1439",
        "storage_key": "property/5762658426945536/019f150b-470b-74cd-afe9-1fb2484c1439.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYcFoCW4dVIgRnyoIAmHTYZY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_e5f4d4e059dce03dc022bb03",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "FastMed Urgent Care Charlotte Mallard Creek",
      "poi_type": "Health and Wellness",
      "poi_address": "2728 W Mallard Creek Church Rd Ste 300, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150d-ca83-7578-9957-0f08878fc1a8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-ca83-7578-9957-0f08878fc1a8",
        "storage_key": "property/5762658426945536/019f150d-ca83-7578-9957-0f08878fc1a8.webp",
        "width": 904,
        "height": 609
      },
      "poi_business_url": "https://www.fastmed.com/urgent-care-centers/charlotte-nc-walk-in-clinic-west-mallard-creek-church-road",
      "poi_directions_map_url": "https://maps.google.com/?cid=12204928611885799257&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fastmed-urgent-care-charlotte-mallard-creek",
      "poi_latitude": "35.3417425",
      "poi_longitude": "-80.7655249",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 980-218-1860",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-470b-74cd-afe9-1fb2484c1439.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-470b-74cd-afe9-1fb2484c1439",
        "storage_key": "property/5762658426945536/019f150b-470b-74cd-afe9-1fb2484c1439.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhe1vMVUcVIgRWVd0dOidYKk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_d0b514af437e4342d687f40f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "10515 Mallard Creek Rd, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150d-cbbb-7483-9b18-d5152ff659f4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-cbbb-7483-9b18-d5152ff659f4",
        "storage_key": "property/5762658426945536/019f150d-cbbb-7483-9b18-d5152ff659f4.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/charlotte-nc-pharmacies/10515-mallard-creek-road-charlotte-nc-28262/storeid=2559?WT.mc_id=LS_GOOGLE_RX_2559",
      "poi_directions_map_url": "https://maps.google.com/?cid=12047423090634507296&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "35.3424104",
      "poi_longitude": "-80.7676571",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 704-547-9739",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150e-1ef6-71c0-9f20-ccfcefdf2fc7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-1ef6-71c0-9f20-ccfcefdf2fc7",
        "storage_key": "property/5762658426945536/019f150e-1ef6-71c0-9f20-ccfcefdf2fc7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJM_Q8k6odVIgRIMQbkHgLMac",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_0e8c8dc97c902c855501c21c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "2800 W Mallard Creek Church Rd, Charlotte, NC 28262, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150d-d9ca-767f-b891-3345016676cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-d9ca-767f-b891-3345016676cc",
        "storage_key": "property/5762658426945536/019f150d-d9ca-767f-b891-3345016676cc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-2800+w+mallard+creek+church+rd-charlotte-nc-28262/id=6480",
      "poi_directions_map_url": "https://maps.google.com/?cid=10963065391076516784&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "35.341578",
      "poi_longitude": "-80.7664626",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 704-549-1272",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-470b-74cd-afe9-1fb2484c1439.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-470b-74cd-afe9-1fb2484c1439",
        "storage_key": "property/5762658426945536/019f150b-470b-74cd-afe9-1fb2484c1439.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkcz93qodVIgRsKN-bOOhJJg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_1ab272203fe8de46a962372d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "Sam's Club Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "8909 JW Clay Blvd, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150d-ce04-724b-bb29-d66b9389aa7b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-ce04-724b-bb29-d66b9389aa7b",
        "storage_key": "property/5762658426945536/019f150d-ce04-724b-bb29-d66b9389aa7b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.samsclub.com/club/6540-charlotte-nc/pharmacy",
      "poi_directions_map_url": "https://maps.google.com/?cid=18417175141388786808&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sams-club-pharmacy",
      "poi_latitude": "35.3145775",
      "poi_longitude": "-80.7537237",
      "poi_miles_from_property": "8.1 mi",
      "poi_walking_minutes": "2 hours 58 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 704-593-0769",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150e-1ef6-71c0-9f20-ccfcefdf2fc7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-1ef6-71c0-9f20-ccfcefdf2fc7",
        "storage_key": "property/5762658426945536/019f150e-1ef6-71c0-9f20-ccfcefdf2fc7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdaxbCDocVIgReByidDbzlv8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_f363dc75290fd4bfb761564a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "Latitude at Mallard Creek",
      "poi_type": "Health and Wellness",
      "poi_address": "655 W Mallard Creek Church Rd, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150d-e44e-74ef-a005-94186c4fa366.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-e44e-74ef-a005-94186c4fa366",
        "storage_key": "property/5762658426945536/019f150d-e44e-74ef-a005-94186c4fa366.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.latitudeatmc.com/?utm_medium=organic&utm_source=google&utm_campaign=gmb-website-button",
      "poi_directions_map_url": "https://maps.google.com/?cid=6996205950965857784&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "latitude-at-mallard-creek",
      "poi_latitude": "35.3268844",
      "poi_longitude": "-80.73545299999999",
      "poi_miles_from_property": "7.0 mi",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 980-300-6407",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-470b-74cd-afe9-1fb2484c1439.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-470b-74cd-afe9-1fb2484c1439",
        "storage_key": "property/5762658426945536/019f150b-470b-74cd-afe9-1fb2484c1439.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIcDh324cVIgR-D3Lsj6EF2E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "apartment_complex"
    },
    {
      "id": "ec_9eda1fb1cf8783cde121b2d7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "4301 Park Rd D, Charlotte, NC 28209, USA",
      "poi_short_description": "Fitness studio offering cardio, strength training and classes that track measurable results via technology. Real-time tracking.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150d-e69e-7229-85f7-b3252e07a060.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-e69e-7229-85f7-b3252e07a060",
        "storage_key": "property/5762658426945536/019f150d-e69e-7229-85f7-b3252e07a060.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/charlotte-north-carolina-1389?utm_medium=seo&utm_source=gg&utm_term=corporate&utm_campaign=soci",
      "poi_directions_map_url": "https://maps.google.com/?cid=12255026751805023249&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "35.1737899",
      "poi_longitude": "-80.84781",
      "poi_miles_from_property": "19.1 mi",
      "poi_walking_minutes": "7 hours 2 mins",
      "poi_biking_minutes": "1 hour 36 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 704-885-2540",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-470b-74cd-afe9-1fb2484c1439.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-470b-74cd-afe9-1fb2484c1439",
        "storage_key": "property/5762658426945536/019f150b-470b-74cd-afe9-1fb2484c1439.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlZj_rROfVogREWQ_nuaZEqo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_c7aa69d39b6a7acf8856fd8e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "Solace Yoga Studio",
      "poi_type": "Health and Wellness",
      "poi_address": "5419 Village Dr NW, Concord, NC 28027, USA",
      "poi_short_description": "Warm studio featuring an array of classes including aerial yoga, as well as workshops.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150d-e4c6-758d-82d5-084665b29ceb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-e4c6-758d-82d5-084665b29ceb",
        "storage_key": "property/5762658426945536/019f150d-e4c6-758d-82d5-084665b29ceb.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.mysolaceyoga.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14804647704391808662&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "solace-yoga-studio",
      "poi_latitude": "35.414067",
      "poi_longitude": "-80.6703621",
      "poi_miles_from_property": "6.9 mi",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 704-787-8719",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-4707-762f-9b0e-8d0ca04144e3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-4707-762f-9b0e-8d0ca04144e3",
        "storage_key": "property/5762658426945536/019f150b-4707-762f-9b0e-8d0ca04144e3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJOXhghv4FVIgRlnYTFaasdM0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "ec_5725e565cf689e380e55d492",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "12325 Copper Way, Charlotte, NC 28277, USA",
      "poi_short_description": "Chain gym offering state-of-the-art facilities, including a pool, sauna, and basketball courts.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150d-ee21-745b-a8e2-e9f20c9a9314.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-ee21-745b-a8e2-e9f20c9a9314",
        "storage_key": "property/5762658426945536/019f150d-ee21-745b-a8e2-e9f20c9a9314.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=990&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=18198357173492202911&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "35.0690344",
      "poi_longitude": "-80.84426599999999",
      "poi_miles_from_property": "26.9 mi",
      "poi_walking_minutes": "9 hours 54 mins",
      "poi_biking_minutes": "2 hours 22 mins",
      "poi_driving_minutes": "34 mins",
      "poi_business_phone": "+1 704-247-9090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-470b-74cd-afe9-1fb2484c1439.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-470b-74cd-afe9-1fb2484c1439",
        "storage_key": "property/5762658426945536/019f150b-470b-74cd-afe9-1fb2484c1439.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCVo_yxmdVogRnz2vJW6Njfw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_42afd8eea13730de75dccf08",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "Reedy Creek Nature Preserve",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2900 Rocky River Rd, Charlotte, NC 28215, USA",
      "poi_short_description": "Creekside walks & fishing spots in woodland with picnic shelters & ruins of pioneer-era cabins.",
      "poi_long_description": "Creekside walks & fishing spots in woodland with picnic shelters & ruins of pioneer-era cabins.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150d-ee14-716b-acf2-b0f632c0bbfd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-ee14-716b-acf2-b0f632c0bbfd",
        "storage_key": "property/5762658426945536/019f150d-ee14-716b-acf2-b0f632c0bbfd.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://parkandrec.mecknc.gov/Places-to-Visit/Nature/reedy-creek-nature-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=4056376883772919066&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "reedy-creek-nature-preserve",
      "poi_latitude": "35.26378750000001",
      "poi_longitude": "-80.71209840000002",
      "poi_miles_from_property": "12.9 mi",
      "poi_walking_minutes": "4 hours 42 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 980-314-1119",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-4749-70cd-b1e5-91ffaa2bc330.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-4749-70cd-b1e5-91ffaa2bc330",
        "storage_key": "property/5762658426945536/019f150b-4749-70cd-b1e5-91ffaa2bc330.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJBYzQOkoZVIgRGg1kwEglSzg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_ece6e3b931963e59a40a5745",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "Frank Liske Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4001 Stough Rd, Concord, NC 28027, USA",
      "poi_short_description": "Popular recreation area with picnic pavilions, fishing & boating lake, athletic fields & mini-golf.",
      "poi_long_description": "Popular recreation area with picnic pavilions, fishing & boating lake, athletic fields & mini-golf.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150d-e06c-746c-8dc3-943f62ab2e91.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-e06c-746c-8dc3-943f62ab2e91",
        "storage_key": "property/5762658426945536/019f150d-e06c-746c-8dc3-943f62ab2e91.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.cabarruscounty.us/Parks/Frank-Liske-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=2006933554194560920&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "frank-liske-park",
      "poi_latitude": "35.361684",
      "poi_longitude": "-80.6182017",
      "poi_miles_from_property": "10.5 mi",
      "poi_walking_minutes": "3 hours 50 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 704-920-2701",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-4749-70cd-b1e5-91ffaa2bc330.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-4749-70cd-b1e5-91ffaa2bc330",
        "storage_key": "property/5762658426945536/019f150b-4749-70cd-b1e5-91ffaa2bc330.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ177AMhAQVIgRmDeUMW8P2hs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_8e78f5159eec7fa804807025",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "Les Myers Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "338 Lawndale Ave SE, Concord, NC 28025, USA",
      "poi_short_description": "Sizable park with a variety of play equipment, several tennis courts, ballfields & walking trails.",
      "poi_long_description": "Sizable park with a variety of play equipment, several tennis courts, ballfields & walking trails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150d-ea3e-711f-9f00-bdccb08ef300.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-ea3e-711f-9f00-bdccb08ef300",
        "storage_key": "property/5762658426945536/019f150d-ea3e-711f-9f00-bdccb08ef300.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.concordnc.gov/departments/parks-recreation/facilities",
      "poi_directions_map_url": "https://maps.google.com/?cid=13830480261806840833&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "les-myers-park",
      "poi_latitude": "35.3991201",
      "poi_longitude": "-80.5594314",
      "poi_miles_from_property": "14.0 mi",
      "poi_walking_minutes": "5 hours 8 mins",
      "poi_biking_minutes": "1 hour 9 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 704-920-5601",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-4749-70cd-b1e5-91ffaa2bc330.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-4749-70cd-b1e5-91ffaa2bc330",
        "storage_key": "property/5762658426945536/019f150b-4749-70cd-b1e5-91ffaa2bc330.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-Q5dkW4OVIgRAVwMZoW8778",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_e4ba07807926e8dceaf59e6a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "Marvin Caldwell Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "362 Georgia St SW, Concord, NC 28025, USA",
      "poi_short_description": "Roomy local park featuring tennis courts, a baseball diamond & multi-use field, plus paved trails.",
      "poi_long_description": "Roomy local park featuring tennis courts, a baseball diamond & multi-use field, plus paved trails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150d-ed62-71d9-aee8-6814be597f3a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-ed62-71d9-aee8-6814be597f3a",
        "storage_key": "property/5762658426945536/019f150d-ed62-71d9-aee8-6814be597f3a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://concordnc.gov/Departments/Parks-Recreation/Parks#Caldwell%20Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=15989792065843209749&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "marvin-caldwell-park",
      "poi_latitude": "35.3942147",
      "poi_longitude": "-80.5834641",
      "poi_miles_from_property": "13.0 mi",
      "poi_walking_minutes": "4 hours 44 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 704-920-5600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-4749-70cd-b1e5-91ffaa2bc330.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-4749-70cd-b1e5-91ffaa2bc330",
        "storage_key": "property/5762658426945536/019f150b-4749-70cd-b1e5-91ffaa2bc330.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJKdPj7jUOVIgRFabxlCon590",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_79d303a32634bb9639b23398",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "Dorton Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5790 Poplar Tent Rd, Concord, NC 28027, USA",
      "poi_short_description": "City park with a soccer field, tennis courts, a disc-golf course, play equipment & picnic shelters.",
      "poi_long_description": "City park with a soccer field, tennis courts, a disc-golf course, play equipment & picnic shelters.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150d-f2f0-734d-b687-8512fe49ab9d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-f2f0-734d-b687-8512fe49ab9d",
        "storage_key": "property/5762658426945536/019f150d-f2f0-734d-b687-8512fe49ab9d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.concordnc.gov/Departments/Parks-Recreation/Facilities",
      "poi_directions_map_url": "https://maps.google.com/?cid=3681378544137101712&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dorton-park",
      "poi_latitude": "35.4089823",
      "poi_longitude": "-80.6736243",
      "poi_miles_from_property": "7.4 mi",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 704-920-5600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-4749-70cd-b1e5-91ffaa2bc330.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-4749-70cd-b1e5-91ffaa2bc330",
        "storage_key": "property/5762658426945536/019f150b-4749-70cd-b1e5-91ffaa2bc330.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJzavaRxwFVIgRkGEJ90fiFjM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_109c11ffdd4397a89bc39094",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "Weddington Road Bark Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8955 Weddington Rd, Concord, NC 28027, USA",
      "poi_short_description": "Bark park with separate spaces for small and large dogs and seating for dog owners.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150d-ff36-736c-aa39-6ccf8a7d83ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-ff36-736c-aa39-6ccf8a7d83ac",
        "storage_key": "property/5762658426945536/019f150d-ff36-736c-aa39-6ccf8a7d83ac.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://concordnc.gov/Departments/Parks-Recreation/Parks#Bark%20Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=16508994257811119300&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "weddington-road-bark-park",
      "poi_latitude": "35.3728237",
      "poi_longitude": "-80.7038773",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 704-920-5600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-4749-70cd-b1e5-91ffaa2bc330.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-4749-70cd-b1e5-91ffaa2bc330",
        "storage_key": "property/5762658426945536/019f150b-4749-70cd-b1e5-91ffaa2bc330.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJB5-4dTUbVIgRxJzLH8-6G-U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dog_park"
    },
    {
      "id": "ec_a11dbb73af4c80bf3c5650a6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "Hector H. Henry II Greenway (The Mills At Rocky River)",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1095 Drake Mill Lane Southwest, Concord, NC 28025, USA",
      "poi_short_description": "Shady dirt path and greenway that runs along segments of the Rocky River, with wooden bridges.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150d-ff54-74a3-a6ff-46895506ed09.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-ff54-74a3-a6ff-46895506ed09",
        "storage_key": "property/5762658426945536/019f150d-ff54-74a3-a6ff-46895506ed09.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://concordnc.gov/Departments/Parks-Recreation/Greenways",
      "poi_directions_map_url": "https://maps.google.com/?cid=10631618061726848481&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hector-h-henry-ii-greenway-the-mills-at-rocky-river",
      "poi_latitude": "35.3154937",
      "poi_longitude": "-80.59297970000001",
      "poi_miles_from_property": "12.1 mi",
      "poi_walking_minutes": "4 hours 25 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-4749-70cd-b1e5-91ffaa2bc330.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-4749-70cd-b1e5-91ffaa2bc330",
        "storage_key": "property/5762658426945536/019f150b-4749-70cd-b1e5-91ffaa2bc330.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJPaye95ERVIgR4RXbZEwYi5M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_098453c5ef1206ef8f6a5827",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "UNC Charlotte Botanical Gardens",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9090 Craver Rd, Charlotte, NC 28262, USA",
      "poi_short_description": "Indoor & outdoor displays of plants from around the world, plus workshops, plant sales & free tours.",
      "poi_long_description": "Indoor & outdoor displays of plants from around the world, plus workshops, plant sales & free tours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-2fc0-75d6-a83f-cdeebb877b52.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-2fc0-75d6-a83f-cdeebb877b52",
        "storage_key": "property/5762658426945536/019f150b-2fc0-75d6-a83f-cdeebb877b52.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://gardens.uncc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4177973296962421892&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "unc-charlotte-botanical-gardens",
      "poi_latitude": "35.3078198",
      "poi_longitude": "-80.72969499999999",
      "poi_miles_from_property": "8.6 mi",
      "poi_walking_minutes": "3 hours 9 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 704-687-0721",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-470b-74cd-afe9-1fb2484c1439.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-470b-74cd-afe9-1fb2484c1439",
        "storage_key": "property/5762658426945536/019f150b-470b-74cd-afe9-1fb2484c1439.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA6cM9xocVIgRhESD5pMk-zk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "ec_f199f8771ee5c0e875a4353d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "Kirk Farm Fields Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "210 E Mallard Creek Church Rd, Charlotte, NC 28262, USA",
      "poi_short_description": "Trail-lined park featuring woods and an open field, plus soccer nets.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150e-06aa-71ea-8e3b-39030cc10625.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-06aa-71ea-8e3b-39030cc10625",
        "storage_key": "property/5762658426945536/019f150e-06aa-71ea-8e3b-39030cc10625.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mecknc.gov/ParkandRec/Parks/ParksByRegion/NorthRegion/Pages/KirkFarmFields.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=3813087192918391643&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kirk-farm-fields-park",
      "poi_latitude": "35.3221854",
      "poi_longitude": "-80.7308485",
      "poi_miles_from_property": "7.5 mi",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 980-314-1001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-4749-70cd-b1e5-91ffaa2bc330.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-4749-70cd-b1e5-91ffaa2bc330",
        "storage_key": "property/5762658426945536/019f150b-4749-70cd-b1e5-91ffaa2bc330.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7azmx3IcVIgRW_t9b5nO6jQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_1e17e235f1778bca35a5bd1c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "Clarks Creek Greenway",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9729 Mallard Creek Rd, Charlotte, NC 28267, USA",
      "poi_short_description": "This 7-mile trail with a wooded creekside setting attracts bikers, runners & skateboarders.",
      "poi_long_description": "This 7-mile trail with a wooded creekside setting attracts bikers, runners & skateboarders.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150e-03ea-75fb-9240-0f567c0fef33.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-03ea-75fb-9240-0f567c0fef33",
        "storage_key": "property/5762658426945536/019f150e-03ea-75fb-9240-0f567c0fef33.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=14285017145315421591&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clarks-creek-greenway",
      "poi_latitude": "35.3345362",
      "poi_longitude": "-80.7740029",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 980-314-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-470b-74cd-afe9-1fb2484c1439.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-470b-74cd-afe9-1fb2484c1439",
        "storage_key": "property/5762658426945536/019f150b-470b-74cd-afe9-1fb2484c1439.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEWo_U0gcVIgRl-3jjGiTPsY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "ec_4f630694f8e2079bd384ad8e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "Rider Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "45 Transit Ct NW, Concord, NC 28025, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150e-05fb-72be-be27-e14a192acf41.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-05fb-72be-be27-e14a192acf41",
        "storage_key": "property/5762658426945536/019f150e-05fb-72be-be27-e14a192acf41.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.ckrider.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15447285532781352266&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rider-transit-center",
      "poi_latitude": "35.4423245",
      "poi_longitude": "-80.60953130000001",
      "poi_miles_from_property": "12.6 mi",
      "poi_walking_minutes": "4 hours 40 mins",
      "poi_biking_minutes": "1 hour 7 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 704-920-7433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150e-1ef0-764c-a1b4-a169901c123b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-1ef0-764c-a1b4-a169901c123b",
        "storage_key": "property/5762658426945536/019f150e-1ef0-764c-a1b4-a169901c123b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxzhcj1cOVIgRSpV2TVnIX9Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "ec_2b367256087cde358a195528",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "AMC Concord Mills 24",
      "poi_type": "Transportation & Transit",
      "poi_address": "8421 Concord Mills Boulevard, Concord, NC 28027, USA",
      "poi_short_description": "Comfortable, clean screening rooms at the mall location of this popular theater chain.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150d-b457-7434-8733-7bfe71c1e846.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-b457-7434-8733-7bfe71c1e846",
        "storage_key": "property/5762658426945536/019f150d-b457-7434-8733-7bfe71c1e846.webp",
        "width": 1280,
        "height": 911
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/charlotte/amc-concord-mills-24?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=17290551946530007973&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-concord-mills-24",
      "poi_latitude": "35.3703321",
      "poi_longitude": "-80.7260192",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 704-979-0200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150e-1ee2-729a-9318-c9b89447ead3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-1ee2-729a-9318-c9b89447ead3",
        "storage_key": "property/5762658426945536/019f150e-1ee2-729a-9318-c9b89447ead3.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJJeT6YqYcVIgRpStc12Jh9O8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_dff2afb336e47926c76672da",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "Concord Mills Blvd - Krispy Kreme",
      "poi_type": "Transportation & Transit",
      "poi_address": "Concord, NC 28027, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=13157934022901175132&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "concord-mills-blvd---krispy-kreme",
      "poi_latitude": "35.3709111",
      "poi_longitude": "-80.7168929",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-470b-74cd-afe9-1fb2484c1439.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-470b-74cd-afe9-1fb2484c1439",
        "storage_key": "property/5762658426945536/019f150b-470b-74cd-afe9-1fb2484c1439.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJa7Sck1kbVIgRXBMNtUdfmrY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_ee320b5431ff5d4e6fe16fdb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Transportation & Transit",
      "poi_address": "5825 Thunder Rd NW, Concord, NC 28027, USA",
      "poi_short_description": "Department store offering grocery items, electronics, home goods and clothing along with a self checkout.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150d-8437-75e8-a780-2f545c746a6d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-8437-75e8-a780-2f545c746a6d",
        "storage_key": "property/5762658426945536/019f150d-8437-75e8-a780-2f545c746a6d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walmart.com/store/4574-concord-nc/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=7627622230872196852&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "35.3786689",
      "poi_longitude": "-80.7247333",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 704-979-2540",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-4743-73b8-b476-6e22a3073eca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-4743-73b8-b476-6e22a3073eca",
        "storage_key": "property/5762658426945536/019f150b-4743-73b8-b476-6e22a3073eca.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ8xdDfKkcVIgR9IYCkAHC2mk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_3e6db6e37e1db20810345aa0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "JW Clay Blvd / UNC Charlotte",
      "poi_type": "Transportation & Transit",
      "poi_address": "9234-9300 N Tryon St, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150e-1273-73f3-9bc8-81393ceddd2d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-1273-73f3-9bc8-81393ceddd2d",
        "storage_key": "property/5762658426945536/019f150e-1273-73f3-9bc8-81393ceddd2d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.charlottenc.gov/CATS/Rail/LYNX-Stations-and-Park-and-Rides/JW-Clay-Station",
      "poi_directions_map_url": "https://maps.google.com/?cid=9941066239111075827&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jw-clay-blvd--unc-charlotte",
      "poi_latitude": "35.3108328",
      "poi_longitude": "-80.7450265",
      "poi_miles_from_property": "8.3 mi",
      "poi_walking_minutes": "3 hours 4 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-470b-74cd-afe9-1fb2484c1439.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-470b-74cd-afe9-1fb2484c1439",
        "storage_key": "property/5762658426945536/019f150b-470b-74cd-afe9-1fb2484c1439.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5wiIej0cVIgR8xfYDhPD9Yk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_4fb5973505e53eb9d6498b77",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "Charlotte Transportation Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "310 E Trade St, Charlotte, NC 28202, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=4144275419840309105&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "charlotte-transportation-center",
      "poi_latitude": "35.2246882",
      "poi_longitude": "-80.8406333",
      "poi_miles_from_property": "15.0 mi",
      "poi_walking_minutes": "5 hours 32 mins",
      "poi_biking_minutes": "1 hour 14 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-470b-74cd-afe9-1fb2484c1439.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-470b-74cd-afe9-1fb2484c1439",
        "storage_key": "property/5762658426945536/019f150b-470b-74cd-afe9-1fb2484c1439.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN63efwChVogRcef2eolsgzk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_fbe49a9eb1065254b2539bf9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "Kannapolis Train Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "201 S Main St, Kannapolis, NC 28081, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150e-0b73-765e-bbe9-f8b954272df5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-0b73-765e-bbe9-f8b954272df5",
        "storage_key": "property/5762658426945536/019f150e-0b73-765e-bbe9-f8b954272df5.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=KAN",
      "poi_directions_map_url": "https://maps.google.com/?cid=16553330046289025198&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kannapolis-train-station",
      "poi_latitude": "35.4961078",
      "poi_longitude": "-80.624883",
      "poi_miles_from_property": "13.1 mi",
      "poi_walking_minutes": "4 hours 52 mins",
      "poi_biking_minutes": "1 hour 14 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150e-1ef8-750b-87ad-acc5954f7015.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-1ef8-750b-87ad-acc5954f7015",
        "storage_key": "property/5762658426945536/019f150e-1ef8-750b-87ad-acc5954f7015.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ06xB0YQIVIgRrpjbSvk9ueU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "ec_eca42b62d959f723db580c3a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "Charlotte Douglas International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "5501 Josh Birmingham Pkwy, Charlotte, NC 28208, USA",
      "poi_short_description": "Airport with rocking chairs, free WiFi & a 60-foot outdoor sculpture symbolizing flight.",
      "poi_long_description": "Airport with rocking chairs, free WiFi & a 60-foot outdoor sculpture symbolizing flight.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150e-1082-7306-bc5e-391edaa404cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-1082-7306-bc5e-391edaa404cf",
        "storage_key": "property/5762658426945536/019f150e-1082-7306-bc5e-391edaa404cf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cltairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1925933632275654455&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "charlotte-douglas-international-airport",
      "poi_latitude": "35.2162994",
      "poi_longitude": "-80.95394280000001",
      "poi_miles_from_property": "23.3 mi",
      "poi_walking_minutes": "8 hours 36 mins",
      "poi_biking_minutes": "2 hours 4 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 704-359-4013",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-4744-7629-9b0c-e6268bca1327.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-4744-7629-9b0c-e6268bca1327",
        "storage_key": "property/5762658426945536/019f150b-4744-7629-9b0c-e6268bca1327.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJidRKt32YVogRN6fEPG9Kuho",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_57303dbe4dc70fdad6b53a37",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "Atrium Health Cabarrus",
      "poi_type": "Major Employers & Offices",
      "poi_address": "920 Church St N, Concord, NC 28025, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150d-cc29-73ee-9081-c9817584fafd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-cc29-73ee-9081-c9817584fafd",
        "storage_key": "property/5762658426945536/019f150d-cc29-73ee-9081-c9817584fafd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://atriumhealth.org/locations/atrium-health-cabarrus?utm_source=GMB&utm_medium=Organic&utm_campaign=GCR",
      "poi_directions_map_url": "https://maps.google.com/?cid=1622612822891421659&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "atrium-health-cabarrus",
      "poi_latitude": "35.4366428",
      "poi_longitude": "-80.6020008",
      "poi_miles_from_property": "12.3 mi",
      "poi_walking_minutes": "4 hours 32 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 704-403-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-4707-762f-9b0e-92252b7ffc81.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-4707-762f-9b0e-92252b7ffc81",
        "storage_key": "property/5762658426945536/019f150b-4707-762f-9b0e-92252b7ffc81.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJeXV8txcPVIgR299v9MOthBY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_1ace90223a98eea0a20c7677",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "Concord Mills",
      "poi_type": "Major Employers & Offices",
      "poi_address": "8111 Concord Mills Boulevard, Concord, NC 28027, USA",
      "poi_short_description": "Large mall with mostly outlet & big-box stores, plus a movie theater, restaurants & an aquarium.",
      "poi_long_description": "Large mall with mostly outlet & big-box stores, plus a movie theater, restaurants & an aquarium.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-1085-70d9-8010-465933c04d62.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-1085-70d9-8010-465933c04d62",
        "storage_key": "property/5762658426945536/019f150b-1085-70d9-8010-465933c04d62.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.simon.com/mall/concord-mills",
      "poi_directions_map_url": "https://maps.google.com/?cid=15278858876011446672&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "concord-mills",
      "poi_latitude": "35.3690086",
      "poi_longitude": "-80.72197059999999",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 704-886-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-4743-73b8-b476-6e22a3073eca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-4743-73b8-b476-6e22a3073eca",
        "storage_key": "property/5762658426945536/019f150b-4743-73b8-b476-6e22a3073eca.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJpU5jZKccVIgRkIH8ZTJpCdQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_53bc71332d322bd74a04f90d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "Charlotte Motor Speedway",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5555 Concord Pkwy S, Concord, NC 28027, USA",
      "poi_short_description": "Iconic NASCAR racetrack in a 95,000-seat stadium, with separate drag-racing & dirt tracks.",
      "poi_long_description": "Iconic NASCAR racetrack in a 95,000-seat stadium, with separate drag-racing & dirt tracks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150d-b36f-74de-be82-546f6ab05f89.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-b36f-74de-be82-546f6ab05f89",
        "storage_key": "property/5762658426945536/019f150d-b36f-74de-be82-546f6ab05f89.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.charlottemotorspeedway.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3877864903075356639&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "charlotte-motor-speedway",
      "poi_latitude": "35.3526259",
      "poi_longitude": "-80.6856586",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 800-455-3267",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-470b-74cd-afe9-1fb2484c1439.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-470b-74cd-afe9-1fb2484c1439",
        "storage_key": "property/5762658426945536/019f150b-470b-74cd-afe9-1fb2484c1439.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi8sDiRsbVIgR39_CYpXx0DU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "race_course"
    },
    {
      "id": "ec_5ed603dd7488d11d09f59a20",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "Cabarrus County Governmental Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "65 Church St S, Concord, NC 28025, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150e-1607-77d9-8cc6-d4f691ae510e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-1607-77d9-8cc6-d4f691ae510e",
        "storage_key": "property/5762658426945536/019f150e-1607-77d9-8cc6-d4f691ae510e.webp",
        "width": 1280,
        "height": 772
      },
      "poi_business_url": "http://www.cabarruscounty.us",
      "poi_directions_map_url": "https://maps.google.com/?cid=11349149599125686418&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cabarrus-county-governmental-center",
      "poi_latitude": "35.410075",
      "poi_longitude": "-80.5783132",
      "poi_miles_from_property": "12.4 mi",
      "poi_walking_minutes": "4 hours 35 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 704-920-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150e-1ef0-764c-a1b4-a169901c123b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-1ef0-764c-a1b4-a169901c123b",
        "storage_key": "property/5762658426945536/019f150e-1ef0-764c-a1b4-a169901c123b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJn5BJsVAOVIgRkkinFm5HgJ0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "government_office"
    },
    {
      "id": "ec_3b328f51a93e9e54f6bae80f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "Cabarrus Arena & Events Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4751 State Hwy 49, Concord, NC 28025, USA",
      "poi_short_description": "Multiuse venue with a ballroom, an arena, exhibition halls, and an outdoor area for meetings and events.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150e-11fe-77ae-8fec-4ffbb71c12ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-11fe-77ae-8fec-4ffbb71c12ca",
        "storage_key": "property/5762658426945536/019f150e-11fe-77ae-8fec-4ffbb71c12ca.webp",
        "width": 667,
        "height": 514
      },
      "poi_business_url": "http://www.cabarrusarena.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16272311680851446342&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cabarrus-arena--events-center",
      "poi_latitude": "35.3890786",
      "poi_longitude": "-80.4990383",
      "poi_miles_from_property": "17.3 mi",
      "poi_walking_minutes": "6 hours 21 mins",
      "poi_biking_minutes": "1 hour 30 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 704-920-3976",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-470b-74cd-afe9-1fb2484c1439.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-470b-74cd-afe9-1fb2484c1439",
        "storage_key": "property/5762658426945536/019f150b-470b-74cd-afe9-1fb2484c1439.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOyehWXUNVIgRRgqXY0Ld0uE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "ec_2e66d48316bbe94ff2636594",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "Rowan-Cabarrus Business and Technology Center (CBTC)",
      "poi_type": "Major Employers & Offices",
      "poi_address": "660 Concord Pkwy N, Concord, NC 28027, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150e-1347-72e6-99a4-51e7d861de67.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-1347-72e6-99a4-51e7d861de67",
        "storage_key": "property/5762658426945536/019f150e-1347-72e6-99a4-51e7d861de67.webp",
        "width": 1165,
        "height": 684
      },
      "poi_business_url": "https://www.rccc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14776862636017741223&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rowan-cabarrus-business-and-technology-center-cbtc",
      "poi_latitude": "35.4178177",
      "poi_longitude": "-80.6128962",
      "poi_miles_from_property": "10.4 mi",
      "poi_walking_minutes": "3 hours 49 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 704-216-7222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-4707-762f-9b0e-8d0ca04144e3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-4707-762f-9b0e-8d0ca04144e3",
        "storage_key": "property/5762658426945536/019f150b-4707-762f-9b0e-8d0ca04144e3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJW8uezp8PVIgRp22Uukb2Ec0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_f7298f9c2e29bc8a96c7e17d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "Cabarrus College of Health Sciences",
      "poi_type": "Major Employers & Offices",
      "poi_address": "401 Medical Park Dr NE, Concord, NC 28025, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150d-9f9e-71ce-84c2-d8d8d4e018c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-9f9e-71ce-84c2-d8d8d4e018c1",
        "storage_key": "property/5762658426945536/019f150d-9f9e-71ce-84c2-d8d8d4e018c1.webp",
        "width": 667,
        "height": 667
      },
      "poi_business_url": "https://cabarruscollege.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1386404138424524097&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cabarrus-college-of-health-sciences",
      "poi_latitude": "35.439955",
      "poi_longitude": "-80.60091150000001",
      "poi_miles_from_property": "12.4 mi",
      "poi_walking_minutes": "4 hours 36 mins",
      "poi_biking_minutes": "1 hour 7 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 704-403-1555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-4707-762f-9b0e-8d0ca04144e3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-4707-762f-9b0e-8d0ca04144e3",
        "storage_key": "property/5762658426945536/019f150b-4707-762f-9b0e-8d0ca04144e3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ3xmozxcPVIgRQd3s6Td_PRM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_adc21898cda24cb69cc8e9a9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "North Carolina Research Campus (NCRC)",
      "poi_type": "Major Employers & Offices",
      "poi_address": "150 N Research Campus Dr, Kannapolis, NC 28081, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150e-159d-77e8-945f-b527cf9a2882.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-159d-77e8-945f-b527cf9a2882",
        "storage_key": "property/5762658426945536/019f150e-159d-77e8-945f-b527cf9a2882.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://ncresearchcampus.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3460680875381704932&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-carolina-research-campus-ncrc",
      "poi_latitude": "35.4999068",
      "poi_longitude": "-80.6234497",
      "poi_miles_from_property": "13.5 mi",
      "poi_walking_minutes": "4 hours 59 mins",
      "poi_biking_minutes": "1 hour 15 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 704-938-5400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-470b-74cd-afe9-1fb2484c1439.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-470b-74cd-afe9-1fb2484c1439",
        "storage_key": "property/5762658426945536/019f150b-470b-74cd-afe9-1fb2484c1439.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ06xB0YQIVIgR5EgdsuvOBjA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "ec_100f57bf0b1c64377491caae",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "Cabarrus Health Alliance",
      "poi_type": "Major Employers & Offices",
      "poi_address": "280 Concord Pkwy S #110a, Concord, NC 28027, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150e-199a-7579-a78c-7f4b9ba97289.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-199a-7579-a78c-7f4b9ba97289",
        "storage_key": "property/5762658426945536/019f150e-199a-7579-a78c-7f4b9ba97289.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.cabarrushealth.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6002848785272183784&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cabarrus-health-alliance",
      "poi_latitude": "35.3989967",
      "poi_longitude": "-80.61085489999999",
      "poi_miles_from_property": "10.3 mi",
      "poi_walking_minutes": "3 hours 48 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 704-920-1070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150b-470b-74cd-afe9-1fb2484c1439.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-470b-74cd-afe9-1fb2484c1439",
        "storage_key": "property/5762658426945536/019f150b-470b-74cd-afe9-1fb2484c1439.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJa4VRpeoPVIgR6JuIbipnTlM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dental_clinic"
    },
    {
      "id": "ec_aca3ede4161ac2db6d23d952",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "poi_name": "Cabarrus County Sheriff's Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "30 Corban Ave SE, Concord, NC 28025, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150e-13a5-70fe-8e1a-ddc745c89069.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-13a5-70fe-8e1a-ddc745c89069",
        "storage_key": "property/5762658426945536/019f150e-13a5-70fe-8e1a-ddc745c89069.webp",
        "width": 640,
        "height": 632
      },
      "poi_business_url": "https://www.cabarruslaw.us/Home",
      "poi_directions_map_url": "https://maps.google.com/?cid=2146114869060322714&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cabarrus-county-sheriffs-office",
      "poi_latitude": "35.4090546",
      "poi_longitude": "-80.5782942",
      "poi_miles_from_property": "12.4 mi",
      "poi_walking_minutes": "4 hours 35 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 704-920-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f150e-1ef0-764c-a1b4-a169901c123b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-1ef0-764c-a1b4-a169901c123b",
        "storage_key": "property/5762658426945536/019f150e-1ef0-764c-a1b4-a169901c123b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQV0x5FAOVIgRmkWGURqIyB0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_15a6c10c-b82d-45a6-b6b8-b5886581c9ca",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_b3888c8f-a231-4f03-bb5d-df4014d7d97a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_d76f3b26-5493-47bd-8825-ca4f788a7e12",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_509249cf-06c2-4836-930d-2e41c4f4f139",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_38c8ec48-191e-4993-957f-24d057ead177",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_7ed4ff56-9b9c-4701-bca3-592011fee41e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_db25b3aaf345c4f3e8a0d948",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "rating": "5",
      "name": "false",
      "text": "I have searched the area for a place to call home within the area of Concord Mills.  I decided on Kings Grant because of the location and price.  I have been very pleased with the apartment size, privacy and my rent rate.  I love the new amenities and the staff.  Everyone has been great to work with.  I have referred several friends and family. Very happy.",
      "date": "false",
      "title": "Prime Location, Great Price  - New"
    },
    {
      "id": "ec_b90689102f1b3ecbf6376884",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "rating": "4",
      "name": "false",
      "text": "Great apartment and location. Lived here for 3 months now. I noticed they had an issue with bad tenants but they have cleared them out. Don't notice an issue with sound from other apartments like another has claimed.",
      "date": "false",
      "title": "Great place to live"
    },
    {
      "id": "ec_12322627619c812ab0d084e8",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "rating": "4",
      "name": "false",
      "text": "I have been living here for a solid month thus far. I have to say, reading the reviews alone will scare anyone away. But a lot of people should remember is that this is apartment living at the end of the day. When complaining about hearing your neighbors, you should kind of expect to hear neighbors. In a perfect apt. world we would all have neighbors that are courteous, respectful, and handle themselves exactly as we would want them to, but this is just what comes with the territory. I've lived in higher end apartments and still have heard my neighbors alarm clock go off for work at 5am.lol What I can say, is that my building is relatively quiet. I hardly see my neighbors aside from in the mornings when everyone is headed to work, & the evenings when everyone is in from work. I feel like the management team is doing the best that they can to weed out what few are left of the \"bad seeds\", of course they cannot see and hear every single thing as it is happening, but when things are reported I've personally seen them do all that they can to resolve issues from my own experience. I also read in the reviews that the cops are always here.. I've seen a few instances where they have been, but I've also seen that the management team has had zero tolerance for nonsense and they do not hesitate to remove tenants if necessary, which is very much appreciated. Everyone's experience is not expected to be the same, because again it is apartment living, we all have different types of neighbors in our buildings. I personally have had no issues with my building & neighbors, but I see others have (to be expected). But it looks to me like a lot of things are clearing up. I haven't experienced even half of what I have been reading in these reviews, THANK GOD.lol A lot of people complain about the kids in the neighborhood playing behind their buildings, and being loud. While I'm not too big a fan of kids in general, I do understand that the kids don't have a designated area just for them to play, so they are doing the best that they can as well. I believe that if the kids have their own designated area, those issues will solve themselves. Reading these reviews alone would make this place seem like a horror movie, but I am glad I did not feed into everything that I have read. The rent, amount of space, location, and amenities I have in my 2 bedroom is unmatched by any apartments I looked at in the Charlotte area. Most of the tenants here are of a working class, and have families.",
      "date": "false",
      "title": "An HONEST review."
    },
    {
      "id": "ec_e3c9b632ea9c9ff59e4d090a",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "rating": "5",
      "name": "false",
      "text": "I would Highly recommend Ardmore Kings Grant! My family moved into 2 bedroom 3 months ago and have loved every minute of living there.The Apartments are Modern and New.The amenities( pool,clubhouse,grilling area,fitness center)are Great and Very CLEAN !( Very important to me and my family)! The stuff is very helpful and  friendly. The maintenance ( K D and Tim ) answers requests immediately. Very professional and helpful.We would HIGHLY recommend this property to anyone ! Thank You for making Ardmore... New Great home for me and my family :) LM_",
      "date": "false",
      "title": "Excellent Property !"
    },
    {
      "id": "ec_e40424fdb234bdc54d749568",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "rating": "5",
      "name": "false",
      "text": "They accepted me & my two hefty dogs and I love them for it. I couldn't possibly imagine moving somewhere that did not accept them. They have a park and  wash station for my dogs. I've had to stay in not so nice places just to find flexible pet policies. This is the nicest place I have lived at with them so far!!!!\n\nOnly con is that I can hear my neighbor. It's annoying sometimes but tolerable.",
      "date": "false",
      "title": "Me and My Dogs LOVE it here!"
    },
    {
      "id": "ec_0af58ef9d73da700bd66c134",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "rating": "4",
      "name": "false",
      "text": "Francisco the leasing agent is very helpful & knowledgable. I definitely would've rented but the space is too small. Awesome community.  Everyone was super friendly on the property. ",
      "date": "false",
      "title": "Awesome Leasing Agent"
    },
    {
      "id": "ec_2694a451b98d7765937804e9",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "rating": "4",
      "name": "false",
      "text": "I moved in June of 2024 from out of state the staff was very accommodating.(Francisco and Alex) Apartment is beautiful and modern. (2 bd 2 bath) No Issues. Whenever I put in a maintenance request they come same day (David is amazing!)  My kids and I utilize all of the amenities, especially the pool in the summer! \n\nThey keep the grounds clean close to lots of shopping and restaurants. I would renew my lease no question. \n\nCMS School District\n \n-S. Evans ",
      "date": "false",
      "title": "Affordable Living Great Area"
    },
    {
      "id": "ec_1b618440c53b059389d7245f",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "rating": "4",
      "name": "false",
      "text": "I can truly say my experience is wonderful especially India she was very welcoming and help me in every way through out my process and that’s what you want when moving into a new area.!!!!!!!! And place.!!!! Not one time did she have a nasty attitude or anything I high recommend.!!!!",
      "date": "false",
      "title": "Excellent.!!!!!!!!!!!!!!!!"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_c9edaf1cca530e488e9aa1d3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f14c4-75f8-7721-89a2-999662bd6050.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c4-75f8-7721-89a2-999662bd6050",
        "storage_key": "property/5762658426945536/019f14c4-75f8-7721-89a2-999662bd6050.webp",
        "width": 800,
        "height": 449
      },
      "virtual_tour_title": "2BR, 2BA - 1,054SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=ELPATTeyhWr"
    },
    {
      "id": "ec_4031aefac1844a4b2dcb7e4c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "YouTube channel: American Landmark",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f14c4-7745-70e7-a629-3605ce5e5da2.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c4-7745-70e7-a629-3605ce5e5da2",
        "storage_key": "property/5762658426945536/019f14c4-7745-70e7-a629-3605ce5e5da2.webp",
        "width": 480,
        "height": 360
      },
      "virtual_tour_title": "Conrad at Concord Mills Community Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://www.youtube.com/embed/RwlCWvbGOeg"
    },
    {
      "id": "ec_18a65cf46f1c811fbedbf84f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f14c4-773f-7160-b460-88610007af36.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c4-773f-7160-b460-88610007af36",
        "storage_key": "property/5762658426945536/019f14c4-773f-7160-b460-88610007af36.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=7k8GzjmLHwa"
    },
    {
      "id": "ec_5169547601d539b4cd594ce9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f14c4-7e8c-726d-bc00-b40b7137831b.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c4-7e8c-726d-bc00-b40b7137831b",
        "storage_key": "property/5762658426945536/019f14c4-7e8c-726d-bc00-b40b7137831b.webp",
        "width": 800,
        "height": 449
      },
      "virtual_tour_title": "Pool",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=CvErqb3d9iX"
    },
    {
      "id": "ec_1b8333af4cdb69f5aa036d2d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f14c4-7ee1-747d-b790-3b080a09c7ce.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c4-7ee1-747d-b790-3b080a09c7ce",
        "storage_key": "property/5762658426945536/019f14c4-7ee1-747d-b790-3b080a09c7ce.webp",
        "width": 800,
        "height": 449
      },
      "virtual_tour_title": "Amenities Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=GvtkcDcT4Kr"
    }
  ],
  "faqs": [
    {
      "id": "custom_608fc884-8a14-4306-8301-eacef0fd5e82",
      "question": "Is Conrad at Concord Mills pet-friendly?",
      "answer": "Yes. Conrad at Concord Mills welcomes cats and dogs, up to 2 pets per home, with no posted weight limit. Some breed restrictions apply. Assistance animals (service animals and emotional support animals) are not pets under fair housing law, so they are not subject to pet fees, deposits, or breed and weight restrictions. For the full pet policy, call the leasing team at (980) 237-6891 or visit our contact page.",
      "category": "Pet Policy",
      "source": "custom"
    },
    {
      "id": "custom_28ed3b56-0fbb-454b-84e1-ffd9690e1868",
      "question": "How can I schedule a tour at Conrad at Concord Mills?",
      "answer": "You can schedule a tour of Conrad at Concord Mills online through our Schedule a Tour page, or call the leasing office at (980) 237-6891. You can also view our virtual tours to see the community before visiting in person.",
      "category": "Contact & Tours",
      "source": "custom"
    },
    {
      "id": "custom_d90423a3-73ed-4601-8696-c2976abcb98a",
      "question": "What are the leasing office hours at Conrad at Concord Mills?",
      "answer": "The Conrad at Concord Mills leasing office is open during these hours:\n\n• Monday: 9:00 AM to 6:00 PM\n• Tuesday: 9:00 AM to 6:00 PM\n• Wednesday: 9:00 AM to 6:00 PM\n• Thursday: 9:00 AM to 6:00 PM\n• Friday: 9:00 AM to 6:00 PM\n• Saturday: 10:00 AM to 5:00 PM\n\nHours may change around holidays. Call (980) 237-6891 or visit our contact page to confirm before you visit.",
      "category": "Office Hours",
      "source": "custom"
    },
    {
      "id": "custom_0483b0bd-4978-49c9-817a-75db30861ec5",
      "question": "What floor plans are available at Conrad at Concord Mills?",
      "answer": "Conrad at Concord Mills offers 1- to 3-bedroom apartment homes ranging from approximately 740 to 1,430 square feet, across 3 floor plans. View layouts, square footage, and current availability on our Floor Plans page, or schedule a tour to see them in person.",
      "category": "Floor Plans & Units",
      "source": "custom"
    },
    {
      "id": "custom_ded9dd25-b221-40f8-89c5-0a4e1c810ced",
      "question": "What amenities does Conrad at Concord Mills have?",
      "answer": "Conrad at Concord Mills offers a range of community and in-home amenities. Community amenities include: American Landmark 360, Car Charging Stations, Coffee Bar, Dog Park, Fitness Center, Garages, Grill Area, Online Resident Services, Outside Space, Pool, Select Homes, Lounge, and Wi-Fi Business Lounge. In-home features include: cabinets, counters, crown molding, fan, hard floors, kitchen appliances, tall ceilings, tile backsplash, usb outlet, w&d connections, and walk-in closet. See the complete list on our Amenities page.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_32f6a2b9-360f-4ed7-8795-0d6a80e56bbf",
      "question": "Where is Conrad at Concord Mills located?",
      "answer": "Conrad at Concord Mills is located at 9015 Kings Grant Dr, Charlotte NC 28262. Nearby you'll find dining at Panera Bread, shopping at Lowes Foods of Concord, and green space at Reedy Creek Nature Preserve. Explore more on our Neighborhood page.",
      "category": "Location & Neighborhood",
      "source": "custom"
    },
    {
      "id": "custom_eb6afc8d-dbad-4474-96da-78688808f6d8",
      "question": "How do I apply to live at Conrad at Concord Mills?",
      "answer": "You can apply to live at Conrad at Concord Mills online through our Apply Now page, which walks you through each step. If you have questions, the leasing team can help. Call (980) 237-6891 or reach out through our contact page.",
      "category": "Application Process",
      "source": "custom"
    },
    {
      "id": "custom_14adfdad-7f7e-4e80-8313-2ca463510595",
      "question": "What do I need to apply at Conrad at Concord Mills?",
      "answer": "Applicants should be ready to provide standard rental application information, including government-issued identification, proof of income, and rental history. Qualification requirements can vary, so we recommend confirming the current criteria with the Conrad at Concord Mills leasing team at (980) 237-6891 or on our contact page. When you're ready, start on the Apply Now page.",
      "category": "Application Process",
      "source": "custom"
    },
    {
      "id": "custom_07bae939-524a-43a6-8043-1070296f11ec",
      "question": "What is the Landmark 360 program at Conrad at Concord Mills?",
      "answer": "Conrad at Concord Mills participates in American Landmark's Landmark 360 resident program, which includes three resident promises:\n\n• Move-In Satisfaction Promise: if you are not satisfied within your first 15 days, American Landmark will refund your deposit and waive lease-termination fees.\n• 48-Hour Maintenance Completion Promise: work orders are completed within 48 hours (Monday through Friday), with rent credits if that timeline is missed.\n• Relocation Promise: after six months on your lease, you can transfer to another American Landmark community without penalties, with 60 days' written notice.\nTo learn more, contact the leasing team at (980) 237-6891 or visit our contact page.",
      "category": "Resident Programs",
      "source": "custom"
    },
    {
      "id": "custom_3e8840a8-f303-4da1-b1fa-e478377003fa",
      "question": "Does Conrad at Concord Mills have a pool?",
      "answer": "Yes. Conrad at Concord Mills has a swimming pool for residents. See it alongside our other community amenities on the Amenities page, or take a look in our virtual tour of the pool.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_467fc0b1-5bfc-44fe-9864-7043cb9d3af9",
      "question": "Does Conrad at Concord Mills have a fitness center?",
      "answer": "Yes. Conrad at Concord Mills has a fitness center for residents. See all amenities on the Amenities page, or schedule a tour to view it in person.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_d388ba1e-b45f-469e-8648-d85b0310c1fd",
      "question": "Does Conrad at Concord Mills have a dog park?",
      "answer": "Yes. Conrad at Concord Mills has an on-site dog park for residents and their dogs. See more community amenities on the Amenities page.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_25e06c1b-7bae-4bab-90ab-445837117856",
      "question": "Does Conrad at Concord Mills offer virtual tours?",
      "answer": "Yes. Conrad at Concord Mills offers virtual tours of 2BR, 2BA - 1,054SF, Conrad at Concord Mills Community Tour, Fitness Center, Pool, and Amenities Center. Start on our Virtual Tours page, then schedule an in-person tour when you are ready.",
      "category": "Contact & Tours",
      "source": "custom"
    },
    {
      "id": "custom_6d010059-8967-4f0b-ac32-f16403d9b660",
      "question": "What do residents say about living at Conrad at Concord Mills?",
      "answer": "Residents frequently mention the helpful staff and responsive maintenance at Conrad at Concord Mills. One resident wrote: *\"They accepted me & my two hefty dogs and I love them for it. I couldn't possibly imagine moving somewhere that did not accept them. They have a park and wash station for my dogs.\"* Read more resident reviews on our Reviews page.",
      "category": "Resident Life",
      "source": "custom"
    },
    {
      "id": "custom_eae480b8-9649-42b9-ba33-3f4898a33bd8",
      "question": "When was Conrad at Concord Mills built?",
      "answer": "Conrad at Concord Mills was built in 2015 and renovated in 2022. Schedule a tour to see the finishes in person.",
      "category": "Property History & Features",
      "source": "custom"
    },
    {
      "id": "custom_fc41917b-676d-4ef2-827a-f4842869d196",
      "question": "What is the pet fee at Conrad at Concord Mills?",
      "answer": "Pets at Conrad at Concord Mills: cats and dogs are welcome, up to 2 per home, with no posted weight limit. Some breed restrictions apply. Assistance animals (service animals and emotional support animals) are not pets under fair housing law, so they are not subject to pet fees, deposits, or breed and weight restrictions. For details, contact the leasing team at (980) 237-6891 or visit our contact page.",
      "category": "Pet Policy",
      "source": "custom"
    },
    {
      "id": "custom_f16fcd18-2a0a-409d-8d1b-e7f39ddf7f4d",
      "question": "What features are included in the apartments at Conrad at Concord Mills?",
      "answer": "Apartment homes at Conrad at Concord Mills include cabinets, counters, crown molding, fan, hard floors, kitchen appliances, tall ceilings, tile backsplash, usb outlet, w&d connections, and walk-in closet. Browse layouts on our Floor Plans page or schedule a tour.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_ae08ee63-863b-404e-9029-be14fb3b9655",
      "question": "What restaurants and shops are near Conrad at Concord Mills?",
      "answer": "Nearby restaurants and shops include Panera Bread, Bonefish Grill, BJ's Restaurant & Brewhouse, and Outback Steakhouse. See the full neighborhood guide on our Neighborhood page.",
      "category": "Location & Neighborhood",
      "source": "custom"
    }
  ],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa45-5ccb-723b-b2b3-d276058814de",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "conrad-at-concord-mills",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536"
    },
    {
      "lead_collector_id": "0198aa45-5d2f-74da-a86d-d9d926a26677",
      "lead_source": "FACEBOOK_ADS",
      "name": "conrad-at-concord-mills",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536"
    },
    {
      "lead_collector_id": "0198aa45-5d92-705c-88f6-7d3f7209b4d4",
      "lead_source": "LANDING_PAGE",
      "name": "conrad-at-concord-mills",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-for-rent-charlotte-nc",
      "search_query": "One Bedroom Apartments For Rent In Charlotte NC",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments For Rent In Charlotte NC",
      "h2_subtitle": "Discover the perfect blend of comfort and convenience at Conrad at Concord Mills. Our one bedroom apartments offer modern features and a prime location near top attractions.",
      "page_copy": "At Conrad at Concord Mills, our one bedroom apartments for rent in Charlotte NC provide spacious floor plans with impressive in-home features like granite countertops, wood-style vinyl flooring, and remote-controlled ceiling fans. Enjoy the convenience of USB outlets and electronic smart locks, ensuring your home is both stylish and functional. \n\nOur community features a sparkling swimming pool and a state-of-the-art fitness center, perfect for unwinding after a long day. Located in Mecklenburg County, our prime location places you near the SEA LIFE Aquarium and the shops at Concord Mills, offering endless dining and shopping options. Experience cozy living spaces, a resort-style community, and a premium location at Conrad at Concord Mills.",
      "featured_image": "https://irp.cdn-website.com/2035f402/dms3rep/multi/1024x768_pool2_knefjf.png",
      "featured_image_media": null,
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f6c0d-e868-772e-93b4-94a8570e8b89.webp",
      "blank_image_media": {
        "alt_text": "exterior view of a community pool area",
        "public_id": "019f6c0d-e868-772e-93b4-94a8570e8b89",
        "storage_key": "property/5762658426945536/019f6c0d-e868-772e-93b4-94a8570e8b89.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Conrad at Concord Mills | One Bedroom Apartments For Rent In Charlotte NC",
      "seo_description": "Find one bedroom apartments for rent in Charlotte NC at Conrad at Concord Mills. Enjoy modern features and a prime location near top attractions. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "custom",
      "page_item_url": "two-bedrooms-apartments-for-rent-charlotte-nc",
      "search_query": "Two Bedrooms Apartments For Rent In Charlotte NC",
      "category": "Floorplan",
      "h1_title": "Two Bedrooms Apartments For Rent In Charlotte NC",
      "h2_subtitle": "Experience spacious living at Conrad at Concord Mills. Our two bedroom apartments feature modern amenities and a prime location near top Charlotte attractions.",
      "page_copy": "At Conrad at Concord Mills, our two bedrooms apartments for rent in Charlotte NC offer expansive floor plans with high-end features such as granite countertops, wood-style vinyl flooring, and designer cabinetry. Enjoy the convenience of USB outlets, electronic smart locks, and remote-controlled ceiling fans, making your home both stylish and functional. \n\nOur community includes a sparkling swimming pool and a state-of-the-art fitness center, perfect for relaxation and staying active. Located in Mecklenburg County, our prime location places you near the SEA LIFE Aquarium and the shops at Concord Mills, providing endless dining and shopping options. Discover cozy living spaces, a resort-style community, and a premium location at Conrad at Concord Mills.",
      "featured_image": "https://irp.cdn-website.com/2035f402/dms3rep/multi/1024x768_pool2_knefjf.png",
      "featured_image_media": null,
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f6c0d-e868-772e-93b4-94a8570e8b89.webp",
      "blank_image_media": {
        "alt_text": "exterior view of a community pool area",
        "public_id": "019f6c0d-e868-772e-93b4-94a8570e8b89",
        "storage_key": "property/5762658426945536/019f6c0d-e868-772e-93b4-94a8570e8b89.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Conrad at Concord Mills | Two Bedrooms Apartments For Rent In Charlotte NC",
      "seo_description": "Find two bedrooms apartments for rent in Charlotte NC at Conrad at Concord Mills. Enjoy modern amenities and a prime location near top attractions. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "custom",
      "page_item_url": "three-bedrooms-apartments-for-rent-charlotte-nc",
      "search_query": "Three Bedrooms Apartments For Rent In Charlotte NC",
      "category": "Floorplan",
      "h1_title": "Three Bedrooms Apartments For Rent In Charlotte NC",
      "h2_subtitle": "Discover spacious living at Conrad at Concord Mills. Our three bedroom apartments feature modern amenities and a prime location near top Charlotte attractions.",
      "page_copy": "At Conrad at Concord Mills, our three bedrooms apartments for rent in Charlotte NC offer expansive floor plans with high-end features such as granite countertops, wood-style vinyl flooring, and designer cabinetry. Enjoy the convenience of USB outlets, electronic smart locks, and remote-controlled ceiling fans, making your home both stylish and functional. \n\nOur community includes a sparkling swimming pool and a state-of-the-art fitness center, perfect for relaxation and staying active. Located in Mecklenburg County, our prime location places you near the SEA LIFE Aquarium and the shops at Concord Mills, providing endless dining and shopping options. Discover cozy living spaces, a resort-style community, and a premium location at Conrad at Concord Mills.",
      "featured_image": "https://irp.cdn-website.com/2035f402/dms3rep/multi/1024x768_pool2_knefjf.png",
      "featured_image_media": null,
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f6c0d-e868-772e-93b4-94a8570e8b89.webp",
      "blank_image_media": {
        "alt_text": "exterior view of a community pool area",
        "public_id": "019f6c0d-e868-772e-93b4-94a8570e8b89",
        "storage_key": "property/5762658426945536/019f6c0d-e868-772e-93b4-94a8570e8b89.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Conrad at Concord Mills | Three Bedrooms Apartments For Rent In Charlotte NC",
      "seo_description": "Find three bedrooms apartments for rent in Charlotte NC at Conrad at Concord Mills. Enjoy modern amenities and a prime location near top attractions. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-resort-inspired-pool",
      "search_query": "Apartments For Rent Near Me with Resort-Inspired Swimming Pool",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Resort-Inspired Swimming Pool",
      "h2_subtitle": "Experience luxury living at Conrad at Concord Mills. Our apartments feature a resort-inspired swimming pool and a host of modern amenities for your convenience.",
      "page_copy": "At Conrad at Concord Mills, our apartments for rent near me with resort-inspired swimming pool offer a luxurious living experience. Our community features a sparkling swimming pool, perfect for relaxing and enjoying the sun. Additionally, our 24-hour modern fitness center and outdoor grilling pavilion provide ample opportunities for recreation and socializing. \n\nLocated in Mecklenburg County, our prime location places you near the SEA LIFE Aquarium and the shops at Concord Mills, offering endless dining and shopping options. Our spacious one, two, and three bedroom apartments come with impressive in-home features like granite countertops, wood-style vinyl flooring, and electronic smart locks. Discover the perfect blend of comfort and convenience at Conrad at Concord Mills.",
      "featured_image": "https://irp.cdn-website.com/2035f402/dms3rep/multi/1024x768_pool2_knefjf.png",
      "featured_image_media": null,
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f6c0d-e868-772e-93b4-94a8570e8b89.webp",
      "blank_image_media": {
        "alt_text": "exterior view of a community pool area",
        "public_id": "019f6c0d-e868-772e-93b4-94a8570e8b89",
        "storage_key": "property/5762658426945536/019f6c0d-e868-772e-93b4-94a8570e8b89.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Conrad at Concord Mills | Apartments For Rent Near Me with Resort-Inspired Swimming Pool",
      "seo_description": "Find apartments for rent near me with resort-inspired swimming pool at Conrad at Concord Mills. Enjoy luxury living with modern amenities and a prime location. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-24hr-modern-fitness-center",
      "search_query": "Apartments For Rent Near Me with 24-Hour Modern Fitness Center",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with 24-Hour Modern Fitness Center",
      "h2_subtitle": "Discover luxury living at Conrad at Concord Mills. Our apartments feature a 24-hour modern fitness center and a range of premium amenities for your convenience.",
      "page_copy": "At Conrad at Concord Mills, our apartments for rent near me with 24-hour modern fitness center offer a luxurious living experience. Our community features a state-of-the-art fitness center available 24/7, allowing you to maintain your fitness routine at any time. Additionally, our resort-inspired swimming pool and outdoor grilling pavilion provide ample opportunities for relaxation and socializing. \n\nLocated in Mecklenburg County, our prime location places you near the SEA LIFE Aquarium and the shops at Concord Mills, offering endless dining and shopping options. Our spacious one, two, and three bedroom apartments come with impressive in-home features like granite countertops, wood-style vinyl flooring, and electronic smart locks. Discover the perfect blend of comfort and convenience at Conrad at Concord Mills.",
      "featured_image": "https://irp.cdn-website.com/2035f402/dms3rep/multi/1024x768_pool2_knefjf.png",
      "featured_image_media": null,
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f6c0d-e868-772e-93b4-94a8570e8b89.webp",
      "blank_image_media": {
        "alt_text": "exterior view of a community pool area",
        "public_id": "019f6c0d-e868-772e-93b4-94a8570e8b89",
        "storage_key": "property/5762658426945536/019f6c0d-e868-772e-93b4-94a8570e8b89.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Conrad at Concord Mills | Apartments For Rent Near Me with 24-Hour Modern Fitness Center",
      "seo_description": "Find apartments for rent near me with 24-hour modern fitness center at Conrad at Concord Mills. Enjoy luxury living with modern amenities and a prime location. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-fenced-pet-park-agility",
      "search_query": "Apartments For Rent Near Me with Fenced Pet Park w/ Agility Course",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Fenced Pet Park w/ Agility Course",
      "h2_subtitle": "Experience pet-friendly living at Conrad at Concord Mills. Our apartments feature a fenced pet park with an agility course and a range of premium amenities.",
      "page_copy": "At Conrad at Concord Mills, our apartments for rent near me with fenced pet park w/ agility course offer a luxurious living experience for you and your furry friends. Our community features a dedicated pet park with an agility course, perfect for keeping your pets active and entertained. Additionally, our resort-inspired swimming pool and 24-hour modern fitness center provide ample opportunities for relaxation and wellness. \n\nLocated in Mecklenburg County, our prime location places you near the SEA LIFE Aquarium and the shops at Concord Mills, offering endless dining and shopping options. Our spacious one, two, and three bedroom apartments come with impressive in-home features like granite countertops, wood-style vinyl flooring, and electronic smart locks. Discover the perfect blend of comfort and convenience at Conrad at Concord Mills.",
      "featured_image": "https://irp.cdn-website.com/2035f402/dms3rep/multi/1024x768_pool2_knefjf.png",
      "featured_image_media": null,
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f6c0d-e868-772e-93b4-94a8570e8b89.webp",
      "blank_image_media": {
        "alt_text": "exterior view of a community pool area",
        "public_id": "019f6c0d-e868-772e-93b4-94a8570e8b89",
        "storage_key": "property/5762658426945536/019f6c0d-e868-772e-93b4-94a8570e8b89.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Conrad at Concord Mills | Apartments For Rent Near Me with Fenced Pet Park w/ Agility Course",
      "seo_description": "Find apartments for rent near me with fenced pet park w/ agility course at Conrad at Concord Mills. Enjoy luxury living with modern amenities and a prime location. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-1-2-3-bedroom-plans",
      "search_query": "Apartments For Rent Near Me with 1, 2 & 3 Bedroom Floor Plans",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with 1, 2 & 3 Bedroom Floor Plans",
      "h2_subtitle": "Discover versatile living at Conrad at Concord Mills. Our apartments feature 1, 2, and 3 bedroom floor plans with modern amenities and a prime location.",
      "page_copy": "At Conrad at Concord Mills, our apartments for rent near me with 1, 2 & 3 bedroom floor plans offer a versatile living experience. Our community features spacious floor plans with impressive in-home features like granite countertops, wood-style vinyl flooring, and designer cabinetry. Enjoy the convenience of USB outlets, electronic smart locks, and remote-controlled ceiling fans, making your home both stylish and functional. \n\nLocated in Mecklenburg County, our prime location places you near the SEA LIFE Aquarium and the shops at Concord Mills, offering endless dining and shopping options. Our resort-inspired swimming pool and 24-hour modern fitness center provide ample opportunities for relaxation and wellness. Discover the perfect blend of comfort and convenience at Conrad at Concord Mills.",
      "featured_image": "https://irp.cdn-website.com/2035f402/dms3rep/multi/1024x768_pool2_knefjf.png",
      "featured_image_media": null,
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f6c0d-e868-772e-93b4-94a8570e8b89.webp",
      "blank_image_media": {
        "alt_text": "exterior view of a community pool area",
        "public_id": "019f6c0d-e868-772e-93b4-94a8570e8b89",
        "storage_key": "property/5762658426945536/019f6c0d-e868-772e-93b4-94a8570e8b89.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Conrad at Concord Mills | Apartments For Rent Near Me with 1, 2 & 3 Bedroom Floor Plans",
      "seo_description": "Find apartments for rent near me with 1, 2 & 3 bedroom floor plans at Conrad at Concord Mills. Enjoy luxury living with modern amenities and a prime location. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "custom",
      "page_item_url": "apartments-for-rent-charlotte-nc-near-atrium-health",
      "search_query": "Apartments For Rent In Charlotte NC Near Atrium Health Cabarrus",
      "category": "POI",
      "h1_title": "Apartments For Rent In Charlotte NC Near Atrium Health Cabarrus",
      "h2_subtitle": "Discover convenient living at Conrad at Concord Mills. Our apartments are located near Atrium Health Cabarrus and feature modern amenities for your comfort.",
      "page_copy": "At Conrad at Concord Mills, our apartments for rent in Charlotte NC near Atrium Health Cabarrus offer a luxurious and convenient living experience. Our community features spacious one, two, and three bedroom floor plans with impressive in-home features like granite countertops, wood-style vinyl flooring, and designer cabinetry. Enjoy the convenience of USB outlets, electronic smart locks, and remote-controlled ceiling fans, making your home both stylish and functional. \n\nLocated in Mecklenburg County, our prime location places you near the SEA LIFE Aquarium and the shops at Concord Mills, offering endless dining and shopping options. Our resort-inspired swimming pool and 24-hour modern fitness center provide ample opportunities for relaxation and wellness. Discover the perfect blend of comfort and convenience at Conrad at Concord Mills, just a short drive from Atrium Health Cabarrus.",
      "featured_image": "https://irp.cdn-website.com/2035f402/dms3rep/multi/1024x768_pool2_knefjf.png",
      "featured_image_media": null,
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f6c0d-e868-772e-93b4-94a8570e8b89.webp",
      "blank_image_media": {
        "alt_text": "exterior view of a community pool area",
        "public_id": "019f6c0d-e868-772e-93b4-94a8570e8b89",
        "storage_key": "property/5762658426945536/019f6c0d-e868-772e-93b4-94a8570e8b89.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Conrad at Concord Mills | Apartments For Rent In Charlotte NC Near Atrium Health Cabarrus",
      "seo_description": "Find apartments for rent in Charlotte NC near Atrium Health Cabarrus at Conrad at Concord Mills. Enjoy luxury living with modern amenities and a prime location. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "custom",
      "page_item_url": "apartments-for-rent-charlotte-nc-near-fresenius-medical-care",
      "search_query": "Apartments For Rent In Charlotte NC Near Fresenius Medical Care at Cmc University",
      "category": "POI",
      "h1_title": "Apartments For Rent In Charlotte NC Near Fresenius Medical Care at Cmc University",
      "h2_subtitle": "Experience convenient living at Conrad at Concord Mills. Our apartments are located near Fresenius Medical Care at Cmc University and feature modern amenities.",
      "page_copy": "At Conrad at Concord Mills, our apartments for rent in Charlotte NC near Fresenius Medical Care at Cmc University offer a luxurious and convenient living experience. Our community features spacious one, two, and three bedroom floor plans with impressive in-home features like granite countertops, wood-style vinyl flooring, and designer cabinetry. Enjoy the convenience of USB outlets, electronic smart locks, and remote-controlled ceiling fans, making your home both stylish and functional. \n\nLocated in Mecklenburg County, our prime location places you near the SEA LIFE Aquarium and the shops at Concord Mills, offering endless dining and shopping options. Our resort-inspired swimming pool and 24-hour modern fitness center provide ample opportunities for relaxation and wellness. Discover the perfect blend of comfort and convenience at Conrad at Concord Mills, just a short drive from Fresenius Medical Care at Cmc University.",
      "featured_image": "https://irp.cdn-website.com/2035f402/dms3rep/multi/1024x768_pool2_knefjf.png",
      "featured_image_media": null,
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f6c0d-e868-772e-93b4-94a8570e8b89.webp",
      "blank_image_media": {
        "alt_text": "exterior view of a community pool area",
        "public_id": "019f6c0d-e868-772e-93b4-94a8570e8b89",
        "storage_key": "property/5762658426945536/019f6c0d-e868-772e-93b4-94a8570e8b89.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Conrad at Concord Mills | Apartments For Rent In Charlotte NC Near Fresenius Medical Care at Cmc University",
      "seo_description": "Find apartments for rent in Charlotte NC near Fresenius Medical Care at Cmc University at Conrad at Concord Mills. Enjoy luxury living with modern amenities and a prime location. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "custom",
      "page_item_url": "apartments-for-rent-charlotte-nc-near-uncc",
      "search_query": "Apartments For Rent In Charlotte NC Near University of North Carolina at Charlotte",
      "category": "POI",
      "h1_title": "Apartments For Rent In Charlotte NC Near University of North Carolina at Charlotte",
      "h2_subtitle": "Discover convenient living at Conrad at Concord Mills. Our apartments are located near the University of North Carolina at Charlotte and feature modern amenities.",
      "page_copy": "At Conrad at Concord Mills, our apartments for rent in Charlotte NC near the University of North Carolina at Charlotte offer a luxurious and convenient living experience. Our community features spacious one, two, and three bedroom floor plans with impressive in-home features like granite countertops, wood-style vinyl flooring, and designer cabinetry. Enjoy the convenience of USB outlets, electronic smart locks, and remote-controlled ceiling fans, making your home both stylish and functional. \n\nLocated in Mecklenburg County, our prime location places you near the SEA LIFE Aquarium and the shops at Concord Mills, offering endless dining and shopping options. Our resort-inspired swimming pool and 24-hour modern fitness center provide ample opportunities for relaxation and wellness. Discover the perfect blend of comfort and convenience at Conrad at Concord Mills, just a short drive from the University of North Carolina at Charlotte.",
      "featured_image": "https://irp.cdn-website.com/2035f402/dms3rep/multi/1024x768_pool2_knefjf.png",
      "featured_image_media": null,
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f6c0d-e868-772e-93b4-94a8570e8b89.webp",
      "blank_image_media": {
        "alt_text": "exterior view of a community pool area",
        "public_id": "019f6c0d-e868-772e-93b4-94a8570e8b89",
        "storage_key": "property/5762658426945536/019f6c0d-e868-772e-93b4-94a8570e8b89.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Conrad at Concord Mills | Apartments For Rent In Charlotte NC Near University of North Carolina at Charlotte",
      "seo_description": "Find apartments for rent in Charlotte NC near the University of North Carolina at Charlotte at Conrad at Concord Mills. Enjoy luxury living with modern amenities and a prime location. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "custom",
      "page_item_url": "apartments-for-rent-charlotte-nc-near-northwest-cabarrus",
      "search_query": "Apartments For Rent In Charlotte NC Near Northwest Cabarrus High School",
      "category": "POI",
      "h1_title": "Apartments For Rent In Charlotte NC Near Northwest Cabarrus High School",
      "h2_subtitle": "Experience convenient living at Conrad at Concord Mills. Our apartments are located near Northwest Cabarrus High School and feature modern amenities for your comfort.",
      "page_copy": "At Conrad at Concord Mills, our apartments for rent in Charlotte NC near Northwest Cabarrus High School offer a luxurious and convenient living experience. Our community features spacious one, two, and three bedroom floor plans with impressive in-home features like granite countertops, wood-style vinyl flooring, and designer cabinetry. Enjoy the convenience of USB outlets, electronic smart locks, and remote-controlled ceiling fans, making your home both stylish and functional. \n\nLocated in Mecklenburg County, our prime location places you near the SEA LIFE Aquarium and the shops at Concord Mills, offering endless dining and shopping options. Our resort-inspired swimming pool and 24-hour modern fitness center provide ample opportunities for relaxation and wellness. Discover the perfect blend of comfort and convenience at Conrad at Concord Mills, just a short drive from Northwest Cabarrus High School.",
      "featured_image": "https://irp.cdn-website.com/2035f402/dms3rep/multi/1024x768_pool2_knefjf.png",
      "featured_image_media": null,
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f6c0d-e868-772e-93b4-94a8570e8b89.webp",
      "blank_image_media": {
        "alt_text": "exterior view of a community pool area",
        "public_id": "019f6c0d-e868-772e-93b4-94a8570e8b89",
        "storage_key": "property/5762658426945536/019f6c0d-e868-772e-93b4-94a8570e8b89.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Conrad at Concord Mills | Apartments For Rent In Charlotte NC Near Northwest Cabarrus High School",
      "seo_description": "Find apartments for rent in Charlotte NC near Northwest Cabarrus High School at Conrad at Concord Mills. Enjoy luxury living with modern amenities and a prime location. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "custom",
      "page_item_url": "discover-apartments-mallard-creek-withrow-downs",
      "search_query": "apartments in mallard creek withrow downs neighborhood",
      "category": "Location",
      "h1_title": "Discover Apartments in Mallard Creek Withrow Downs Neighborhood",
      "h2_subtitle": "Conrad at Concord Mills features 1 and 2 bedroom apartments in Charlotte, NC. Explore our floor plans, photos, and community amenities today!",
      "page_copy": "Welcome to Conrad at Concord Mills, where you can find exceptional apartments in Mallard Creek Withrow Downs neighborhood. Our community features spacious 1 and 2 bedroom apartments designed to meet your lifestyle needs. Located at 9015 Kings Grant Dr, Charlotte, NC 28262, our apartments offer modern amenities and a convenient location. Enjoy easy access to shopping, dining, and entertainment options, all within a vibrant neighborhood setting. Discover the perfect blend of comfort and convenience at Conrad at Concord Mills.",
      "featured_image": "https://irp.cdn-website.com/2035f402/dms3rep/multi/1024x768_pool2_knefjf.png",
      "featured_image_media": null,
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f6c0d-e868-772e-93b4-94a8570e8b89.webp",
      "blank_image_media": {
        "alt_text": "exterior view of a community pool area",
        "public_id": "019f6c0d-e868-772e-93b4-94a8570e8b89",
        "storage_key": "property/5762658426945536/019f6c0d-e868-772e-93b4-94a8570e8b89.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Conrad at Concord Mills | Apartments in Mallard Creek Withrow Downs Neighborhood",
      "seo_description": "Conrad at Concord Mills offers 1 and 2 bedroom apartments in Mallard Creek Withrow Downs neighborhood, Charlotte, NC. View floor plans, photos, and amenities today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "custom",
      "page_item_url": "discover-apartments-near-cox-mill-elementary",
      "search_query": "apartments near cox mill elementary",
      "category": "Location",
      "h1_title": "Discover Apartments Near Cox Mill Elementary",
      "h2_subtitle": "Conrad at Concord Mills features 1 and 2 bedroom apartments in Charlotte, NC. Explore our floor plans, photos, and community amenities today!",
      "page_copy": "Welcome to Conrad at Concord Mills, where you can find the perfect apartments near Cox Mill Elementary. Our community offers spacious 1 and 2 bedroom apartments designed to meet your lifestyle needs. Located at 9015 Kings Grant Dr, Charlotte, NC 28262, our apartments provide easy access to top-rated schools, shopping, and dining options. Enjoy modern amenities and a vibrant community atmosphere that makes Conrad at Concord Mills the ideal place to call home. Schedule a tour today and see why our apartments near Cox Mill Elementary are the perfect choice for you and your family.",
      "featured_image": "https://irp.cdn-website.com/2035f402/dms3rep/multi/1024x768_pool2_knefjf.png",
      "featured_image_media": null,
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f6c0d-e868-772e-93b4-94a8570e8b89.webp",
      "blank_image_media": {
        "alt_text": "exterior view of a community pool area",
        "public_id": "019f6c0d-e868-772e-93b4-94a8570e8b89",
        "storage_key": "property/5762658426945536/019f6c0d-e868-772e-93b4-94a8570e8b89.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Conrad at Concord Mills | Apartments Near Cox Mill Elementary",
      "seo_description": "Conrad at Concord Mills offers 1 and 2 bedroom apartments near Cox Mill Elementary in Charlotte, NC. View floor plans, photos, and amenities today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-charlotte-nc-near-mallard-creek",
      "search_query": "apartments for rent in charlotte nc near mallard creek",
      "category": "POI",
      "h1_title": "Discover Apartments for Rent in Charlotte NC Near Mallard Creek",
      "h2_subtitle": "Conrad at Concord Mills features 1 and 2 bedroom apartments in a prime location. Explore our floor plans, photos, and community amenities today!",
      "page_copy": "Welcome to Conrad at Concord Mills, where you can find exceptional apartments for rent in Charlotte NC near Mallard Creek. Our community features spacious 1 and 2 bedroom apartments designed to meet your lifestyle needs. Located at 9015 Kings Grant Dr, our apartments offer easy access to the best of Charlotte, including shopping, dining, and entertainment options. Enjoy our top-notch community amenities and beautifully designed floor plans. Visit us today to see why Conrad at Concord Mills is the perfect place to call home.",
      "featured_image": "https://irp.cdn-website.com/2035f402/dms3rep/multi/1024x768_pool2_knefjf.png",
      "featured_image_media": null,
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f6c0d-e868-772e-93b4-94a8570e8b89.webp",
      "blank_image_media": {
        "alt_text": "exterior view of a community pool area",
        "public_id": "019f6c0d-e868-772e-93b4-94a8570e8b89",
        "storage_key": "property/5762658426945536/019f6c0d-e868-772e-93b4-94a8570e8b89.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Conrad at Concord Mills | Apartments for Rent in Charlotte NC Near Mallard Creek",
      "seo_description": "Discover Conrad at Concord Mills, offering 1 and 2 bedroom apartments for rent in Charlotte NC near Mallard Creek. View floor plans, photos, and amenities today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "custom",
      "page_item_url": "apartments-for-rent-charlotte-nc-near-rowan-cabarrus",
      "search_query": "apartments for rent in charlotte nc near rowan-cabarrus",
      "category": "POI",
      "h1_title": "Apartments for Rent in Charlotte NC Near Rowan-Cabarrus",
      "h2_subtitle": "Discover the perfect blend of comfort and convenience at Conrad at Concord Mills. Explore our 1 and 2 bedroom apartments today!",
      "page_copy": "Conrad at Concord Mills offers exceptional apartments for rent in Charlotte NC near Rowan-Cabarrus. Our community features spacious 1 and 2 bedroom floor plans designed to meet your lifestyle needs. Enjoy modern amenities, including a state-of-the-art fitness center, resort-style swimming pool, and beautifully landscaped grounds. Located at 9015 Kings Grant Dr, our apartments provide easy access to shopping, dining, and entertainment options. Experience the best of Charlotte living at Conrad at Concord Mills. Schedule a tour today and see why our apartments for rent in Charlotte NC near Rowan-Cabarrus are the perfect place to call home.",
      "featured_image": "https://irp.cdn-website.com/2035f402/dms3rep/multi/1024x768_pool2_knefjf.png",
      "featured_image_media": null,
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f6c0d-e868-772e-93b4-94a8570e8b89.webp",
      "blank_image_media": {
        "alt_text": "exterior view of a community pool area",
        "public_id": "019f6c0d-e868-772e-93b4-94a8570e8b89",
        "storage_key": "property/5762658426945536/019f6c0d-e868-772e-93b4-94a8570e8b89.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Conrad at Concord Mills | Apartments for Rent in Charlotte NC Near Rowan-Cabarrus",
      "seo_description": "Discover Conrad at Concord Mills, offering 1 and 2 bedroom apartments for rent in Charlotte NC near Rowan-Cabarrus. View floor plans, photos, and amenities today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "custom",
      "page_item_url": "apartments-for-rent-charlotte-nc-near-unc",
      "search_query": "apartments for rent in charlotte nc near unc charlotte",
      "category": "POI",
      "h1_title": "Apartments for Rent in Charlotte NC Near UNC Charlotte",
      "h2_subtitle": "Discover Conrad at Concord Mills, offering 1 and 2 bedroom apartments. Explore our floor plans, photos, and community amenities today!",
      "page_copy": "Welcome to Conrad at Concord Mills, your premier destination for apartments for rent in Charlotte NC near UNC Charlotte. Our community features spacious 1 and 2 bedroom apartments designed to meet your lifestyle needs. Located at 9015 Kings Grant Dr, Charlotte, NC 28262, our apartments provide easy access to UNC Charlotte and the vibrant city life. Enjoy a variety of community amenities and modern apartment features that make Conrad at Concord Mills the perfect place to call home. Schedule a tour today and see why our residents love living here!",
      "featured_image": "https://irp.cdn-website.com/2035f402/dms3rep/multi/1024x768_pool2_knefjf.png",
      "featured_image_media": null,
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f6c0d-e868-772e-93b4-94a8570e8b89.webp",
      "blank_image_media": {
        "alt_text": "exterior view of a community pool area",
        "public_id": "019f6c0d-e868-772e-93b4-94a8570e8b89",
        "storage_key": "property/5762658426945536/019f6c0d-e868-772e-93b4-94a8570e8b89.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Conrad at Concord Mills | Apartments for Rent in Charlotte NC Near UNC Charlotte",
      "seo_description": "Discover Conrad at Concord Mills offering 1 and 2 bedroom apartments for rent in Charlotte NC near UNC Charlotte. View floor plans, photos, and amenities today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-rent-charlotte-nc-near-conrad",
      "search_query": "pet friendly apartments for rent in charlotte nc near conrad",
      "category": "Pet-Friendly",
      "h1_title": "Pet Friendly Apartments for Rent in Charlotte NC Near Conrad",
      "h2_subtitle": "Discover the perfect home for you and your furry friends at Conrad at Concord Mills. Our 1 and 2 bedroom apartments offer modern amenities and a welcoming community.",
      "page_copy": "Welcome to Conrad at Concord Mills, where you can find pet friendly apartments for rent in Charlotte NC near Conrad. Our community features spacious 1 and 2 bedroom floor plans designed to accommodate your lifestyle. Enjoy modern amenities, including a fitness center, swimming pool, and pet park, all within a vibrant and welcoming environment. Located at 9015 Kings Grant Dr, our apartments provide easy access to shopping, dining, and entertainment options. Experience the best of Charlotte living with your furry friends at Conrad at Concord Mills.",
      "featured_image": "https://irp.cdn-website.com/2035f402/dms3rep/multi/1024x768_pool2_knefjf.png",
      "featured_image_media": null,
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f6c0d-e868-772e-93b4-94a8570e8b89.webp",
      "blank_image_media": {
        "alt_text": "exterior view of a community pool area",
        "public_id": "019f6c0d-e868-772e-93b4-94a8570e8b89",
        "storage_key": "property/5762658426945536/019f6c0d-e868-772e-93b4-94a8570e8b89.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Conrad at Concord Mills | Pet Friendly Apartments for Rent",
      "seo_description": "Find pet friendly apartments for rent in Charlotte NC near Conrad at Conrad at Concord Mills. Explore our 1 and 2 bedroom floor plans and community amenities today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-rent-charlotte-nc-university-meadows",
      "search_query": "pet friendly apartments for rent in charlotte nc near university meadows elementary",
      "category": "Pet-Friendly",
      "h1_title": "Pet Friendly Apartments for Rent in Charlotte NC Near University Meadows Elementary",
      "h2_subtitle": "Discover the perfect home for you and your furry friends at Conrad at Concord Mills. Our 1 and 2 bedroom apartments offer modern amenities and a convenient location.",
      "page_copy": "Welcome to Conrad at Concord Mills, where you can find pet friendly apartments for rent in Charlotte NC near University Meadows Elementary. Our community features spacious 1 and 2 bedroom floor plans designed to accommodate your lifestyle. Enjoy modern amenities, including a fitness center, swimming pool, and pet park, all within a short distance from University Meadows Elementary. Located at 9015 Kings Grant Dr, our apartments provide easy access to shopping, dining, and entertainment options in Charlotte, NC. Experience the comfort and convenience of living at Conrad at Concord Mills today!",
      "featured_image": "https://irp.cdn-website.com/2035f402/dms3rep/multi/1024x768_pool2_knefjf.png",
      "featured_image_media": null,
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f6c0d-e868-772e-93b4-94a8570e8b89.webp",
      "blank_image_media": {
        "alt_text": "exterior view of a community pool area",
        "public_id": "019f6c0d-e868-772e-93b4-94a8570e8b89",
        "storage_key": "property/5762658426945536/019f6c0d-e868-772e-93b4-94a8570e8b89.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Conrad at Concord Mills | Pet Friendly Apartments for Rent",
      "seo_description": "Find pet friendly apartments for rent in Charlotte NC near University Meadows Elementary at Conrad at Concord Mills. Explore our 1 and 2 bedroom floor plans today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "custom",
      "page_item_url": "luxury-apartments-rent-charlotte-nc-near-conrad-mills",
      "search_query": "luxury apartments for rent in charlotte nc near conrad mills",
      "category": "POI",
      "h1_title": "Luxury Apartments for Rent in Charlotte NC Near Conrad Mills",
      "h2_subtitle": "Discover the elegance and comfort of Conrad at Concord Mills. Our 1 and 2 bedroom apartments offer premium living in a prime location.",
      "page_copy": "Welcome to Conrad at Concord Mills, where luxury meets convenience. Our luxury apartments for rent in Charlotte NC near Conrad Mills feature spacious 1 and 2 bedroom floor plans designed to suit your lifestyle. Enjoy modern amenities, beautifully landscaped grounds, and a vibrant community atmosphere. Located at 9015 Kings Grant Dr, our apartments provide easy access to shopping, dining, and entertainment options. Experience the best of Charlotte living at Conrad at Concord Mills.",
      "featured_image": "https://irp.cdn-website.com/2035f402/dms3rep/multi/1024x768_pool2_knefjf.png",
      "featured_image_media": null,
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f6c0d-e868-772e-93b4-94a8570e8b89.webp",
      "blank_image_media": {
        "alt_text": "exterior view of a community pool area",
        "public_id": "019f6c0d-e868-772e-93b4-94a8570e8b89",
        "storage_key": "property/5762658426945536/019f6c0d-e868-772e-93b4-94a8570e8b89.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Conrad at Concord Mills | Luxury Apartments for Rent in Charlotte NC Near Conrad Mills",
      "seo_description": "Explore Conrad at Concord Mills for luxury apartments for rent in Charlotte NC near Conrad Mills. View floor plans, photos, and amenities today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5762658426945536",
      "source": "custom",
      "page_item_url": "luxury-apartments-rent-charlotte-nc-near-bank-america-stadium",
      "search_query": "luxury apartments for rent in charlotte nc near Bank of America Stadium",
      "category": "POI",
      "h1_title": "Luxury Apartments for Rent in Charlotte NC Near Bank of America Stadium",
      "h2_subtitle": "Discover Conrad at Concord Mills, where luxury meets convenience. Explore our 1 and 2 bedroom apartments in Charlotte, NC, and enjoy top-tier amenities.",
      "page_copy": "Welcome to Conrad at Concord Mills, your premier destination for luxury apartments for rent in Charlotte NC near Bank of America Stadium. Our community features meticulously designed 1 and 2 bedroom apartments that offer the perfect blend of comfort and style. Each apartment is equipped with modern finishes and high-end appliances to ensure a luxurious living experience. Located at 9015 Kings Grant Dr, Charlotte, NC 28262, Conrad at Concord Mills is just minutes away from the excitement of Bank of America Stadium. Enjoy easy access to shopping, dining, and entertainment options, all while living in a serene and upscale environment. View our floor plans, browse through our photo gallery, and discover the exceptional community amenities that make Conrad at Concord Mills the ideal place to call home.",
      "featured_image": "https://irp.cdn-website.com/2035f402/dms3rep/multi/1024x768_pool2_knefjf.png",
      "featured_image_media": null,
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5762658426945536/019f6c0d-e868-772e-93b4-94a8570e8b89.webp",
      "blank_image_media": {
        "alt_text": "exterior view of a community pool area",
        "public_id": "019f6c0d-e868-772e-93b4-94a8570e8b89",
        "storage_key": "property/5762658426945536/019f6c0d-e868-772e-93b4-94a8570e8b89.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Conrad at Concord Mills | Luxury Apartments for Rent in Charlotte NC Near Bank of America Stadium",
      "seo_description": "Discover Conrad at Concord Mills, offering luxury apartments for rent in Charlotte NC near Bank of America Stadium. Explore our 1 and 2 bedroom floor plans and amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "2154"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "2486465417"
    },
    {
      "ID": "custom_leasing_ai",
      "type": "STRING",
      "value": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a26\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a26\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4939304"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-N6SKN37"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "1"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "3165"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "8443831915"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "0e11f1c6bdc9bed3"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "1f195820242ac1100a1b122d7087a021"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/d7p1oe62vkx"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/f8a42d9f-18da-4964-af2a-064ba794faf4"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "980-499-7465"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Ik95OVBEbGZScGp6K2JGYm9BRFRoQnc9PSIsInZhbHVlIjoiVHJqMThGcWxURllBajFzS3UvaHU0UT09IiwibWFjIjoiZGYyZDRkNzkwOTY2NGNiZmU3ZDc3OTQ4NmY2NzdiYjcyNTYzNmViOGY5ODI2MmJiYTU1MTJiNGY0NzE5MDZmYSJ9"
    },
    {
      "ID": "custom_household_income_qualification_multiplier",
      "type": "FLOAT",
      "value": "3"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "2154",
  "custom_repli_id": "2486465417",
  "custom_leasing_ai": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a26\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a26\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />",
  "custom_realpage_id": "4939304",
  "custom_google_gtm_id": "GTM-N6SKN37",
  "custom_rollout_phase": "1",
  "custom_ads_subscription": "full_stack",
  "custom_knock_company_id": "3165",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "8443831915",
  "custom_knock_community_id": "0e11f1c6bdc9bed3",
  "custom_knock_company_token": "1f195820242ac1100a1b122d7087a021",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/d7p1oe62vkx",
  "custom_self_guided_tour_url": "https://selftournow.com/property/f8a42d9f-18da-4964-af2a-064ba794faf4",
  "custom_website_subscription": "custom",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_ppc_tracking_phone_number": "980-499-7465",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Ik95OVBEbGZScGp6K2JGYm9BRFRoQnc9PSIsInZhbHVlIjoiVHJqMThGcWxURllBajFzS3UvaHU0UT09IiwibWFjIjoiZGYyZDRkNzkwOTY2NGNiZmU3ZDc3OTQ4NmY2NzdiYjcyNTYzNmViOGY5ODI2MmJiYTU1MTJiNGY0NzE5MDZmYSJ9",
  "custom_household_income_qualification_multiplier": "3",
  "custom_audioeye_site_id": "e6d02fd5-c4d4-4761-8f0d-4c1298aecc7b",
  "custom_audioeye_site_hash": "11486ae63c26effcfdf0f2e46607f46c"
};

export const generatedAt = '2026-11-03T20:36:58.117Z';
